(function() {
  'use strict';
  let mountedZones;
  let cleanup = function () {};
  let refreshCartBinding = function () {};
  function initialize() {
  const nextZones = document.getElementById('pd-pers-zones');
  if (!nextZones) return;
  if (mountedZones === nextZones) { refreshCartBinding(); return; }
  cleanup();
  mountedZones = nextZones;
  window.GhostFitPersonalization = null;
  const SVG_NS = 'http://www.w3.org/2000/svg';

  const dataEl = document.getElementById('ghostfit-personalization-data');
  const colorsEl = document.getElementById('ghostfit-school-colors');
  if (!dataEl || !colorsEl) return;

  let config, schoolColors;
  try {
    config = JSON.parse(dataEl.textContent);
    schoolColors = JSON.parse(colorsEl.textContent);
  } catch (e) {
    console.error('[personalization] failed to parse data blobs', e);
    return;
  }
  if (!config) return;

  // Store-wide name/number face from collection metafield
  // ghostfit.personalization_font (injected on #ghostfit-school-colors).
  // One id for every location. Not a shopper picker — availableFonts stays
  // length 1. Fallback is the blob's availableFonts[0] (usually athletic-block).
  const STORE_NAME_NUMBER_FONTS = {
    'athletic-block': true,
    script: true,
    zeroathletics: true,
    modern: true
  };
  // Store-wide lockup from collection metafield ghostfit.personalization_lockup
  // (injected on #ghostfit-school-colors): 'number-over-name' is the Pequot
  // Lakes jacket look (number on top at 75%, name under it at 25%, a lone name
  // at the name-band height). Anything else is the classic jersey. Print reads
  // the same setting from the teamStores doc (orderwebhook production-handoff).
  const STORE_LOCKUP = String((schoolColors && schoolColors.lockup) || '').trim();
  // Store-wide mode from collection metafield ghostfit.personalization_mode
  // (injected on #ghostfit-school-colors): numbers_only / names_only take the
  // blocked field out of every location. 'off' never reaches this file (the
  // modal's gate), and blank or unknown is both. The tier ladder prices
  // locations, not fields, so nothing else changes.
  const STORE_MODE = String((schoolColors && schoolColors.mode) || '').trim();
  const MODE_COPY = personalizationModeCopy(STORE_MODE);
  // Pure (the theme tests run them): the fields a mode keeps, and its wording.
  function fieldsForMode(fields, mode) {
    const blocked = mode === 'numbers_only' ? 'name' : mode === 'names_only' ? 'number' : null;
    return blocked ? (fields || []).filter(function (f) { return f && f.id !== blocked; }) : fields;
  }
  function personalizationModeCopy(mode) {
    if (mode === 'numbers_only') return { what: 'number', ask: 'Add a number.', missing: 'Add a number before saving.', placeholders: { number: 'Number' } };
    if (mode === 'names_only') return { what: 'name', ask: 'Add a name.', missing: 'Add a name before saving.', placeholders: { name: 'Name' } };
    return { what: 'name or number', ask: 'Add a name, a number, or both.', missing: 'Add a name or number before saving.', placeholders: { name: 'Name (optional)', number: 'Number (optional)' } };
  }
  function resolvePreviewFont(zone) {
    const storeFont = String((schoolColors && schoolColors.font) || '').trim();
    if (STORE_NAME_NUMBER_FONTS[storeFont]) return storeFont;
    const fonts = zone && zone.template && zone.template.availableFonts;
    return (fonts && fonts[0]) || 'athletic-block';
  }

  // -------------------------------------------------------------------
  // Normalize the metafield shape into a zones[] array. Phase 1's
  // metafield builder always emits zones[], but existing metafields
  // written before Phase 1 ship may still carry only the legacy
  // {templateId, template, calibration} keys. Both shapes work here:
  // when zones[] is missing/empty but legacy keys exist, wrap them as
  // a single-zone array so the rest of this file only deals with zones.
  // -------------------------------------------------------------------
  let zones = Array.isArray(config.zones) ? config.zones.filter(Boolean) : [];
  if (zones.length === 0 && config.templateId && config.template && config.calibration) {
    zones = [{
      id: 'default',
      label: null,
      templateId: config.templateId,
      template: config.template,
      calibration: config.calibration
    }];
  }
  if (zones.length === 0) return;

  // -------------------------------------------------------------------
  // Defensive hydration guard. Every zone this file renders dereferences a
  // fully-expanded `zone.template` (availableFonts / defaultInkColor / fields /
  // pricing / availableInkColors — see zoneStates.map, buildZoneFields,
  // renderZoneSVG). The createproducts metafield builders hydrate that
  // server-side, but a blob written by an older/drifted service revision (or
  // hand-edited in the Shopify admin) can arrive as a RAW productConfig dump:
  // zones carrying only {templateId, mockupAnchor, fieldLayout} and no
  // `template`. Dereferencing `zone.template.availableFonts[0]` on such a zone
  // throws a TypeError at boot and takes down the ENTIRE personalize UI for the
  // product. Drop any unhydrated zone (loudly) so the remaining valid zones
  // still render; bail cleanly if none survive (product reads as
  // non-personalized rather than broken).
  function zoneTemplateUsable(zone) {
    const t = zone && zone.template;
    return !!t
      && Array.isArray(t.availableFonts) && t.availableFonts.length > 0
      && Array.isArray(t.fields)
      && Array.isArray(t.availableInkColors)
      && !!t.pricing && typeof t.pricing === 'object'
      && typeof t.defaultInkColor === 'string';
  }
  const usableZones = zones.filter(zoneTemplateUsable);
  if (usableZones.length !== zones.length) {
    const dropped = zones.filter(z => !zoneTemplateUsable(z)).map(z => (z && z.id) || '?');
    console.error(
      '[personalization] dropping zone(s) with no expanded template: ' + dropped.join(', ') +
      ' — the ghostfit.personalization metafield was written without server-side template hydration'
    );
  }
  zones = usableZones;
  if (zones.length === 0) return;

  // -------------------------------------------------------------------
  // DOM refs (only the static ones — per-zone DOM is built dynamically).
  // -------------------------------------------------------------------
  const zonesContainer = document.getElementById('pd-pers-zones');
  // Optional preview scoping: the Apple modal sets data-preview-root on
  // #pd-pers-zones so the engine drives the MODAL's preview image / overlay /
  // thumbs instead of the page gallery (which reuses #pd-main-img + .pd-thumb).
  // Unset -> everything resolves globally; the inline block + other themes are
  // byte-for-byte unchanged.
  const previewRoot = (zonesContainer && zonesContainer.dataset && zonesContainer.dataset.previewRoot)
    ? document.querySelector(zonesContainer.dataset.previewRoot) : null;
  // The blob's pricing.perLocation is the ONE per-location price, and 0 means
  // house brand. Publish it on the container so gf-storefront.js (which never
  // parses the blob) reads the same fact instead of re-deriving it from a
  // liquid attribute that can disagree with what the product actually carries.
  if (zonesContainer) {
    zonesContainer.dataset.perLocation = String(
      config.pricing && config.pricing.perLocation != null ? config.pricing.perLocation : ''
    );
  }
  const previewScope = previewRoot || document;
  let svg = previewScope.querySelector('#pd-pers-svg');
  const exactPreviewBtn = document.getElementById('pd-pers-exact-preview');
  const resetBtn = document.getElementById('pd-pers-reset');
  const priceBadge = document.getElementById('pd-pers-price');
  // CTA price element — v4 hero ships #pd-cta-price; standard themes use
  // various class-based selectors. Try a few.
  const ctaPrice = document.getElementById('pd-cta-price')
    || document.querySelector('[data-product-price]')
    || document.querySelector('.price__regular .price-item')
    || document.querySelector('.product__price [data-price]');
  const globalViewHint = document.getElementById('pd-pers-view-hint');

  // Find the main product image. The v4 hero ships #pd-main-img; for the
  // gf-personalization-block section dropped onto other product templates,
  // fall back to common Shopify product-section selectors.
  let mainImg = previewRoot
    ? (previewRoot.querySelector('[data-pers-preview-img]') || previewRoot.querySelector('#pd-main-img'))
    : document.getElementById('pd-main-img');
  if (!mainImg && !previewRoot) {
    const fallbackSelectors = [
      '.product__media-item.is-active img',
      '.product__media img',
      '.product-media img',
      '.product-gallery__main-image img',
      '.product-gallery img',
      'product-media img',
      'media-gallery img',
      'main .product img',
      'main img'
    ];
    for (const sel of fallbackSelectors) {
      const el = document.querySelector(sel);
      if (el && el.tagName === 'IMG') { mainImg = el; break; }
    }
  }

  // If no SVG overlay exists in the DOM, create one inside the main image's
  // wrapper and overlay it. The wrapper becomes position:relative so the
  // SVG can stretch over the image with absolute positioning.
  if (mainImg && !svg) {
    const wrapper = mainImg.parentElement;
    if (wrapper) {
      const wrapperStyle = window.getComputedStyle(wrapper);
      if (wrapperStyle.position === 'static') wrapper.style.position = 'relative';
      svg = document.createElementNS(SVG_NS, 'svg');
      svg.id = 'pd-pers-svg';
      svg.classList.add('pd-pers-svg');
      svg.setAttribute('viewBox', '0 0 1000 1000');
      svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
      svg.setAttribute('aria-hidden', 'true');
      // Inline styles in case the theme CSS doesn't ship .pd-pers-svg
      svg.style.position = 'absolute';
      svg.style.inset = '0';
      svg.style.width = '100%';
      svg.style.height = '100%';
      svg.style.pointerEvents = 'none';
      svg.style.zIndex = '2';
      wrapper.appendChild(svg);
    }
  }

  // Gallery thumbnails — v4 hero uses .pd-thumb; standard Shopify product
  // sections use various selectors. Try several.
  let thumbs = Array.from(previewScope.querySelectorAll('.pd-thumb'));
  if (thumbs.length === 0 && !previewRoot) {
    thumbs = Array.from(document.querySelectorAll(
      '.product__media-list button, .product__media-item button, .product-gallery__thumbnail, .gallery-thumbnail, [data-product-thumbnail]'
    ));
  }

  if (!zonesContainer || !svg) return;

  const isMultiZone = zones.length > 1;
  // Opt-in (the Apple modal sets data-auto-enable on #pd-pers-zones): start every
  // zone enabled and render no per-zone toggle. Defaults OFF, so the inline block's
  // multi-zone toggle UX is unchanged.
  const autoEnableZones = !!(zonesContainer.dataset && zonesContainer.dataset.autoEnable);
  const basePriceCents = parsePriceCents(ctaPrice && ctaPrice.textContent);

  // -------------------------------------------------------------------
  // Wisconsin hanger test only. Live stores have no wisconsinOffer on the
  // blob and keep the existing single-zone / fill-the-box engine.
  // -------------------------------------------------------------------
  // Presence tokens only (blob / field-id existence). Stacked paint ignores
  // y + fontSizePct — live metafields still ship leftover-band leftovers
  // (name 22% / number 48%) that would shrink name+number vs name-only.
  const STACKED_FIELD_LAYOUT = {
    name: { x: 0.5, y: 0.18, fontSizePct: 0.22, align: 'center' },
    number: { x: 0.5, y: 0.68, fontSizePct: 0.48, align: 'center' }
  };
  // Name+number partitions the SAME approved location box as name-only /
  // number-only; the slices come from GfStackedLockup (see stackedSliceBox).
  const HOODIE_BACK_BOX = { x: 0.3327, y: 0.391, w: 0.3415, h: 0.2775 };
  const SLEEVE_VIEW_LEFT_BOX = { x: 0.4416, y: 0.4194, w: 0.12, h: 0.1 };
  const SLEEVE_VIEW_RIGHT_BOX = { x: 0.4647, y: 0.4579, w: 0.1117, h: 0.0931 };
  const JOGGER_BACK_YOKE_BOX = { x: 0.378, y: 0.198, w: 0.244, h: 0.128 };
  const CLASS_LANDMARKS = {
    'hoodie-pullover': {
      back: HOODIE_BACK_BOX,
      'center-back': HOODIE_BACK_BOX,
      'full-chest': { x: 0.3327, y: 0.3000, w: 0.3415, h: 0.2775 },
      'left-chest': { x: 0.5624, y: 0.39, w: 0.1024, h: 0.0854 },
      'left-sleeve': SLEEVE_VIEW_LEFT_BOX,
      'right-sleeve': SLEEVE_VIEW_RIGHT_BOX
    },
    tee: {
      back: { x: 0.3380, y: 0.3600, w: 0.3320, h: 0.2600 },
      'full-chest': { x: 0.3380, y: 0.2900, w: 0.3320, h: 0.2600 },
      'left-chest': { x: 0.5520, y: 0.3050, w: 0.1100, h: 0.0900 },
      'left-sleeve': SLEEVE_VIEW_LEFT_BOX,
      'right-sleeve': SLEEVE_VIEW_RIGHT_BOX
    },
    polo: {
      back: { x: 0.3400, y: 0.3550, w: 0.3280, h: 0.2500 },
      'full-chest': { x: 0.3400, y: 0.2850, w: 0.3280, h: 0.2500 },
      'left-chest': { x: 0.5450, y: 0.2930, w: 0.0910, h: 0.0710 },
      'left-sleeve': SLEEVE_VIEW_LEFT_BOX,
      'right-sleeve': SLEEVE_VIEW_RIGHT_BOX
    },
    'quarter-zip': {
      back: { x: 0.3360, y: 0.3700, w: 0.3360, h: 0.2650 },
      'full-chest': { x: 0.3360, y: 0.2950, w: 0.3360, h: 0.2650 },
      'left-chest': { x: 0.5545, y: 0.2825, w: 0.0850, h: 0.0680 },
      'left-sleeve': SLEEVE_VIEW_LEFT_BOX,
      'right-sleeve': SLEEVE_VIEW_RIGHT_BOX
    },
    crew: {
      back: { x: 0.3340, y: 0.3800, w: 0.3380, h: 0.2700 },
      'full-chest': { x: 0.3340, y: 0.2980, w: 0.3380, h: 0.2700 },
      'left-chest': { x: 0.5460, y: 0.3120, w: 0.1120, h: 0.0920 },
      'left-sleeve': SLEEVE_VIEW_LEFT_BOX,
      'right-sleeve': SLEEVE_VIEW_RIGHT_BOX
    },
    jogger: {
      back: JOGGER_BACK_YOKE_BOX,
      'left-leg': { x: 0.5000, y: 0.4800, w: 0.1600, h: 0.2000 }
    }
  };
  const WI_VIEWS = [
    { id: 'front', label: 'Front', locations: ['left-chest', 'full-chest', 'left-leg'] },
    { id: 'back', label: 'Back', locations: ['back'] },
    { id: 'left-side', label: 'Left sleeve', locations: ['left-sleeve'] },
    { id: 'right-side', label: 'Right sleeve', locations: ['right-sleeve'] }
  ];
  const WI_LOCATION_GEO = {
    'right-sleeve': { label: 'Right Sleeve', view: 'right-side', viewImageIndex: 3 },
    back: { label: 'Back', view: 'back', viewImageIndex: 1 },
    'left-sleeve': { label: 'Left Sleeve', view: 'left-side', viewImageIndex: 2 },
    'left-chest': { label: 'Left Chest', view: 'front', viewImageIndex: 0 },
    'full-chest': { label: 'Full Chest', view: 'front', viewImageIndex: 0 },
    'left-leg': { label: 'Left Leg', view: 'front', viewImageIndex: 0 }
  };
  // Grant-verified occupancy + ink. Live metafields still have zones[] only —
  // this catalog is the dropdown / ink source of truth until attach rewrites
  // locations[] onto the blob.
  const VERIFIED_WI = [
    { handle: 'nike-swoosh-sleeve-rlegend-tee-928', styles: ['NKDX8730'], classId: 'tee', color: 'University Red', occupied: ['full-chest', 'left-sleeve'], open: ['right-sleeve', 'back'], inks: ['black', 'white', 'school-secondary'] },
    { handle: 'nike-youth-swoosh-sleeve-rlegend-tee-927', styles: ['NKDX8787'], classId: 'tee', color: 'University Red', occupied: ['full-chest', 'left-sleeve'], open: ['right-sleeve', 'back'], inks: ['black', 'white', 'school-secondary'] },
    { handle: 'mens-ultimate365-lightweight-quarter-zip-pullover-884', styles: ['A430'], classId: 'quarter-zip', color: 'Power Red', occupied: ['left-chest', 'left-sleeve'], open: ['right-sleeve', 'back'], inks: ['black', 'white', 'school-secondary'] },
    { handle: 'lane-seven-unisex-premium-pullover-1282', styles: [], classId: 'hoodie-pullover', color: 'Cardinal', occupied: ['full-chest'], open: ['right-sleeve', 'left-sleeve', 'back'], inks: ['black', 'white', 'school-secondary'] },
    { handle: 'sport-tek-posicharge-competitor-tee-4993', styles: ['ST350'], classId: 'tee', color: 'Cardinal', occupied: ['full-chest'], open: ['right-sleeve', 'left-sleeve', 'back'], inks: ['black', 'white', 'school-secondary'] },
    { handle: 'ghostfit-mens-prime-hoodie-4587', styles: ['GSF101'], classId: 'hoodie-pullover', color: 'Gray', occupied: ['full-chest'], open: ['right-sleeve', 'left-sleeve', 'back'], inks: ['black', 'white', 'school-primary', 'school-secondary'] },
    { handle: 'next-level-unisex-sueded-tee-5246', styles: ['PC61'], classId: 'tee', color: 'White', occupied: ['full-chest'], open: ['right-sleeve', 'left-sleeve', 'back'], inks: ['black', 'school-primary'] },
    { handle: 'ghostfit-mens-prime-quarter-zip-343', styles: [], classId: 'quarter-zip', color: 'Gray', occupied: ['left-chest'], open: ['right-sleeve', 'left-sleeve', 'back'], inks: ['black', 'white', 'school-primary', 'school-secondary'] },
    { handle: 'nike-dri-fit-micro-pique-2-0-polo-399', styles: ['NKDC1963'], classId: 'polo', color: 'Anthracite', occupied: ['left-chest', 'left-sleeve'], open: ['right-sleeve', 'back'], inks: ['black', 'white', 'school-primary', 'school-secondary'] },
    { handle: 'nike-womens-dri-fit-micro-pique-2-0-polo-920', styles: ['NKDC1991'], classId: 'polo', color: 'White', occupied: ['left-chest', 'left-sleeve'], open: ['right-sleeve', 'back'], inks: ['black', 'school-primary'] },
    { handle: 'adidas-mens-polo-470', styles: ['A401'], classId: 'polo', color: 'White', occupied: ['left-chest', 'left-sleeve'], open: ['right-sleeve', 'back'], inks: ['black', 'school-primary'] },
    { handle: 'adidas-womens-quarter-zip-627', styles: ['A589'], classId: 'quarter-zip', color: 'Grey', occupied: ['left-chest', 'right-sleeve'], open: ['left-sleeve', 'back'], inks: ['black', 'white', 'school-primary', 'school-secondary'] },
    { handle: 'ghostfit-womens-ultralux-hoodie-702', styles: [], classId: 'hoodie-pullover', color: 'Gray', occupied: ['full-chest'], open: ['right-sleeve', 'left-sleeve', 'back'], inks: ['black', 'white', 'school-primary', 'school-secondary'] },
    { handle: 'ghostfit-mens-tour-tee-702', styles: [], classId: 'tee', color: 'Gray', occupied: ['full-chest'], open: ['right-sleeve', 'left-sleeve', 'back'], inks: ['black', 'white', 'school-primary', 'school-secondary'] },
    { handle: 'ghostfit-womens-tour-tee-354', styles: [], classId: 'tee', color: 'Gray', occupied: ['full-chest'], open: ['right-sleeve', 'left-sleeve', 'back'], inks: ['black', 'white', 'school-primary', 'school-secondary'] },
    { handle: 'ghostfit-mens-prime-jogger-282', styles: [], classId: 'jogger', color: 'Black', occupied: ['left-leg'], open: ['back'], inks: ['white', 'school-primary', 'school-secondary'] },
    { handle: 'ghostfit-mens-ultralux-crewneck-65', styles: [], classId: 'crew', color: 'Black', occupied: ['full-chest'], open: ['right-sleeve', 'left-sleeve', 'back'], inks: ['white', 'school-primary', 'school-secondary'] },
    { handle: 'ghostfit-mens-player-polo-312', styles: [], classId: 'polo', color: 'Black', occupied: ['left-chest'], open: ['right-sleeve', 'left-sleeve', 'back'], inks: ['white', 'school-primary', 'school-secondary'] }
  ];
  // Wisconsin's own palette. ONLY the two test stores may fall back to it —
  // every other store resolves ink from its blob / #ghostfit-school-colors.
  const WI_TEST_SCHOOL_COLORS = { primary: '#C5050C', secondary: '#FFFFFF' };
  const LOCATION_OVERLAPS = {
    'full-chest': ['left-chest'],
    'full-front': ['left-chest'],
    'left-chest': ['full-chest']
  };
  function expandOccupiedIds(ids) {
    const locked = {};
    (ids || []).forEach(function (id) {
      locked[id] = true;
      (LOCATION_OVERLAPS[id] || []).forEach(function (other) { locked[other] = true; });
    });
    return locked;
  }
  function isSleeveLocationId(id) {
    return id === 'left-sleeve' || id === 'right-sleeve';
  }
  function sleeveViewBoxFor(id) {
    return id === 'left-sleeve' ? SLEEVE_VIEW_LEFT_BOX : SLEEVE_VIEW_RIGHT_BOX;
  }
  function isWrongSleeveBox(box) {
    if (!box) return true;
    if (box.x === HOODIE_BACK_BOX.x && box.y === HOODIE_BACK_BOX.y) return true;
    if (box.x === 0.3 && box.w === 0.4 && box.h === 0.45) return true;
    if (box.w >= 0.18 || box.h >= 0.18) return true;
    if (box.x < 0.28) return true;
    return false;
  }
  function approvedThemeBox(id, classId) {
    if (isSleeveLocationId(id)) {
      const landmarks = CLASS_LANDMARKS[classId] || CLASS_LANDMARKS.tee;
      const classBox = landmarks && landmarks[id];
      if (classBox && !isWrongSleeveBox(classBox)) return Object.assign({}, classBox);
      return Object.assign({}, sleeveViewBoxFor(id));
    }
    if (classId === 'jogger' && id === 'back') {
      return Object.assign({}, JOGGER_BACK_YOKE_BOX);
    }
    const landmarks = CLASS_LANDMARKS[classId] || CLASS_LANDMARKS.tee;
    return Object.assign({}, (landmarks && landmarks[id]) || HOODIE_BACK_BOX);
  }
  // One print box per location. Logo / name / number / name+number all
  // decorate inside that product print space. Never restamp CLASS_LANDMARKS
  // over a box the blob already has. Landmarks are fallback only.
  function isUsablePrintBox(box) {
    if (!box) return false;
    if (![box.x, box.y, box.w, box.h].every(function (n) {
      return typeof n === 'number' && isFinite(n);
    })) return false;
    if (box.w <= 0 || box.h <= 0) return false;
    // Generic V2 leftover — not a product override.
    if (box.x === 0.3 && box.y === 0.3 && box.w === 0.4 && box.h === 0.45) return false;
    return true;
  }
  function locationPrintBox(loc, classId) {
    const blobBox = loc && ((loc.mockupAnchor && loc.mockupAnchor.box) || loc.box);
    if (isUsablePrintBox(blobBox)) return Object.assign({}, blobBox);
    return approvedThemeBox(loc && loc.id, classId);
  }
  function wisconsinLocationRecord(id, classId) {
    const geo = WI_LOCATION_GEO[id];
    if (!geo) return null;
    const box = approvedThemeBox(id, classId);
    return {
      id: id,
      label: geo.label,
      view: geo.view,
      viewImageIndex: geo.viewImageIndex,
      classId: classId || null,
      mockupAnchor: { view: geo.view, viewImageIndex: geo.viewImageIndex, box: Object.assign({}, box) },
      fieldLayout: {
        name: Object.assign({}, STACKED_FIELD_LAYOUT.name),
        number: Object.assign({}, STACKED_FIELD_LAYOUT.number)
      }
    };
  }
  function lookupVerifiedWisconsin(handle, style) {
    const h = String(handle || '').trim().toLowerCase().replace(/^\/+|\/+$/g, '');
    const s = String(style || '').trim().toUpperCase();
    for (let i = 0; i < VERIFIED_WI.length; i++) {
      const row = VERIFIED_WI[i];
      if (h && (h === row.handle || h.indexOf(row.handle) !== -1)) return row;
    }
    if (s) {
      for (let i = 0; i < VERIFIED_WI.length; i++) {
        if ((VERIFIED_WI[i].styles || []).indexOf(s) !== -1) return VERIFIED_WI[i];
      }
    }
    return null;
  }
  function readGarmentFromPdp() {
    const swatch = document.querySelector('#swatch-row .swatch.is-active');
    const hex = (swatch && (swatch.dataset.hex || '').trim()) || '';
    const name = ((document.getElementById('pd-color-name') || {}).textContent || '').trim();
    return { family: name.toLowerCase().replace(/\s+/g, '-'), hex: hex, name: name };
  }
  function synthesizeWisconsinOffer(locations) {
    const locs = (locations && locations.length) ? locations : zones.map(z => {
      const cal = z.calibration || {};
      const box = (cal.mockupAnchor && cal.mockupAnchor.box) || HOODIE_BACK_BOX;
      return {
        id: z.id || 'back',
        label: z.label || prettyViewLabel(cal.view) || 'Back',
        view: cal.view || 'back',
        viewImageIndex: cal.viewImageIndex,
        mockupAnchor: { view: cal.view || 'back', viewImageIndex: cal.viewImageIndex, box: box },
        fieldLayout: cal.fieldLayout && cal.fieldLayout.name && cal.fieldLayout.number
          ? cal.fieldLayout
          : { name: Object.assign({}, STACKED_FIELD_LAYOUT.name), number: Object.assign({}, STACKED_FIELD_LAYOUT.number) }
      };
    });
    return {
      scope: 'wisconsin-hanger-test',
      addon: 10,
      defaultType: 'name-number',
      types: config.types || [
        { id: 'name', label: 'Name', fields: ['name'] },
        { id: 'number', label: 'Number', fields: ['number'] },
        { id: 'name-number', label: 'Name + Number', fields: ['name', 'number'] }
      ],
      locations: locs,
      occupancy: config.occupancy || [],
      garmentColor: config.garmentColor || readGarmentFromPdp(),
      schoolColors: config.schoolColors || schoolColors || (wiStoreFlag ? Object.assign({}, WI_TEST_SCHOOL_COLORS) : null),
      ink: config.ink || null,
      brand: ''
    };
  }
  // Two flags, deliberately different. data-wisconsin is emitted ONLY for the
  // two Wisconsin hanger-test store ids (gf-personalize-modal.liquid's
  // wisconsin_hanger_test), so it is the only thing allowed to unlock the
  // VERIFIED_WI catalog. The .is-wisconsin class is WIDER — hanger_mode sets it
  // for any store whose blob carries locations[] — so it may switch the hanger
  // UI on, but it must never import Wisconsin's inks / occupancy: a new store's
  // GSF101 hoodie (ghostfit-mens-prime-hoodie-4588) was matching Wisconsin's row
  // by STYLE and inheriting its #C5050C ink and its occupied locations.
  const wiStoreFlag = !!(zonesContainer.dataset && zonesContainer.dataset.wisconsin === 'true');
  const wiFlag = wiStoreFlag || !!(document.querySelector('.gf-pz-modal.is-wisconsin'));
  const productHandle = (zonesContainer.dataset && zonesContainer.dataset.handle)
    || window.GHOSTFIT_PRODUCT_HANDLE
    || '';
  const productStyle = (zonesContainer.dataset && zonesContainer.dataset.style) || '';
  // Opted-in stores get locations[] / ink / occupancy from their OWN blob; only
  // the two test stores fall back to the hand-verified catalog.
  const verifiedWi = wiStoreFlag ? lookupVerifiedWisconsin(productHandle, productStyle) : null;
  const blobLocations = (config.wisconsinOffer && config.wisconsinOffer.locations)
    || config.locations
    || null;
  const hasBlobLocations = Array.isArray(blobLocations) && blobLocations.length > 0;
  const wiOffer = (config.wisconsinOffer && config.wisconsinOffer.scope === 'wisconsin-hanger-test')
    ? config.wisconsinOffer
    : (wiFlag || hasBlobLocations || verifiedWi
      ? synthesizeWisconsinOffer(hasBlobLocations ? blobLocations : null)
      : null);
  if (wiOffer) {
    if (hasBlobLocations) {
      wiOffer.locations = blobLocations;
    } else if (verifiedWi) {
      wiOffer.locations = verifiedWi.open.map(function (id) {
        return wisconsinLocationRecord(id, verifiedWi.classId || (wiOffer && wiOffer.classId));
      }).filter(Boolean);
    }
    if (verifiedWi && !wiOffer.classId) wiOffer.classId = verifiedWi.classId;
    if (!wiOffer.views) wiOffer.views = (config.views || {});
    const occIds = (wiOffer.occupancy || []).map(function (o) { return o.id; })
      .concat((verifiedWi && verifiedWi.occupied) || []);
    const overlapLocked = expandOccupiedIds(occIds);
    if (overlapLocked['full-chest'] || overlapLocked['full-front']) overlapLocked['left-chest'] = true;
    overlapLocked['left-leg'] = true;
    overlapLocked['left-thigh'] = true;
    wiOffer.locations = (wiOffer.locations || []).filter(function (loc) {
      return loc && loc.id && !overlapLocked[loc.id];
    });
    (wiOffer.locations || []).forEach(function (loc) {
      const classId = wiOffer.classId || (verifiedWi && verifiedWi.classId);
      const stamped = wisconsinLocationRecord(loc.id, classId);
      const box = locationPrintBox(loc, classId);
      loc.mockupAnchor = {
        view: (stamped && stamped.view) || loc.view || (loc.mockupAnchor && loc.mockupAnchor.view),
        viewImageIndex: stamped && stamped.viewImageIndex != null
          ? stamped.viewImageIndex
          : loc.viewImageIndex,
        box: Object.assign({}, box)
      };
      if (stamped) {
        loc.view = stamped.view;
        loc.viewImageIndex = stamped.viewImageIndex;
        loc.fieldLayout = loc.fieldLayout || stamped.fieldLayout;
      }
    });
    if ((!Array.isArray(wiOffer.ink) || !wiOffer.ink.length) && verifiedWi) {
      wiOffer.ink = verifiedWi.inks.slice();
    }
    if ((!wiOffer.occupancy || !wiOffer.occupancy.length) && verifiedWi) {
      wiOffer.occupancy = verifiedWi.occupied.map(function (id) { return { id: id }; });
    }
    if (verifiedWi && !(wiOffer.garmentColor && (wiOffer.garmentColor.name || wiOffer.garmentColor.family))) {
      wiOffer.garmentColor = {
        family: verifiedWi.color.toLowerCase().replace(/\s+/g, '-'),
        name: verifiedWi.color,
        hex: ''
      };
    }
    if (!wiOffer.schoolColors || !wiOffer.schoolColors.primary) {
      wiOffer.schoolColors = wiStoreFlag
        ? Object.assign({}, WI_TEST_SCHOOL_COLORS)
        : Object.assign({}, schoolColors || {});
    }
    if (!(wiOffer.garmentColor && wiOffer.garmentColor.hex)) {
      const fromPdp = readGarmentFromPdp();
      if (fromPdp.hex || fromPdp.family) {
        wiOffer.garmentColor = Object.assign({}, wiOffer.garmentColor || {}, fromPdp);
      }
    }
  }
  function wisconsinActive() { return !!wiOffer; }
  // House-brand (Ghost Fit / GhostFit / Ghost Fit Apparel / Ghost Fit Sports):
  // customization is FREE. Liquid sets data-house-brand from product.vendor,
  // custom.brand_partner / custom.brand, title, and tags.
  function isGhostFitHouseBrand() {
    // The blob is the authority in BOTH directions: perLocation === 0 IS the
    // house-brand price, and any price above 0 means v4 minted a paid variant
    // ladder — so a numeric price settles it and the liquid attributes below
    // never get a say. They are the fallback ONLY for blobs that predate
    // pricing[]. (Some Nike/Adidas products carry vendor "Ghostfit Apparel",
    // so the attribute alone called a $10 product free and the storefront
    // never swapped to the paid variant.)
    if (config && config.pricing && typeof config.pricing.perLocation === 'number') {
      return config.pricing.perLocation === 0;
    }
    const dlg = document.getElementById('gf-pz-dialog');
    if (dlg && dlg.getAttribute('data-house-brand') === 'true') return true;
    if (zonesContainer && zonesContainer.getAttribute('data-house-brand') === 'true') return true;
    return false;
  }
  const wiStamps = {};
  let wiType = (wiOffer && wiOffer.defaultType) || 'name-number';
  let wiLocationId = wiOffer && Array.isArray(wiOffer.locations) && wiOffer.locations[0]
    ? wiOffer.locations[0].id : '';
  if (wiOffer && wiLocationId && !(wiOffer.locations || []).some(function (l) { return l.id === wiLocationId; })) {
    wiLocationId = wiOffer.locations[0] ? wiOffer.locations[0].id : '';
  }
  if (wiOffer && wiLocationId && wisconsinOccupiedSet()[wiLocationId]) {
    const firstOpen = (wiOffer.locations || []).find(function (l) { return l && l.id && !wisconsinOccupiedSet()[l.id]; });
    wiLocationId = firstOpen ? firstOpen.id : '';
  }

  function wisconsinOccupiedSet() {
    const ids = ((wiOffer && wiOffer.occupancy) || []).map(function (o) { return o.id; })
      .concat((verifiedWi && verifiedWi.occupied) || []);
    const locked = expandOccupiedIds(ids);
    if (locked['full-chest'] || locked['full-front']) locked['left-chest'] = true;
    locked['left-leg'] = true;
    locked['left-thigh'] = true;
    return locked;
  }
  function wisconsinOpenLocationForView(view) {
    const spec = WI_VIEWS.find(v => v.id === view);
    const ids = (spec && spec.locations) || [];
    const occupied = wisconsinOccupiedSet();
    const open = (wiOffer.locations || []).filter(function (l) {
      return l && l.id && !occupied[l.id];
    });
    for (let i = 0; i < ids.length; i++) {
      const id = ids[i];
      if (occupied[id]) continue;
      if (id === 'left-chest' && (occupied['full-chest'] || occupied['full-front'])) continue;
      if (id === 'left-leg' || id === 'left-thigh') continue;
      if (open.some(function (l) { return l.id === id; })) return id;
    }
    return null;
  }
  // Location menu: all four garment locations, in garment order. An open
  // location resolves to its offered record; a location the logo, a brand
  // mark, or an unapproved print box has taken stays LISTED but disabled, so
  // the shopper sees why a sleeve or the front is not on offer instead of a
  // two-entry menu. Joggers have no sleeves.
  const WI_LOCATION_MENU = [
    { id: 'front', label: 'Front', ids: ['left-chest', 'full-chest', 'left-leg'] },
    { id: 'back', label: 'Back', ids: ['back'] },
    { id: 'left-sleeve', label: 'Left Sleeve', ids: ['left-sleeve'] },
    { id: 'right-sleeve', label: 'Right Sleeve', ids: ['right-sleeve'] }
  ];
  const WI_LOCATION_UNAVAILABLE = ' (not available)';
  function wisconsinLocationOptions() {
    const offered = (wiOffer && wiOffer.locations) || [];
    const occupied = wisconsinOccupiedSet();
    const jogger = wisconsinIsJogger();
    const out = [];
    WI_LOCATION_MENU.forEach(function (m) {
      if (jogger && (m.id === 'left-sleeve' || m.id === 'right-sleeve')) return;
      const open = offered.find(function (l) { return l && l.id && m.ids.indexOf(l.id) !== -1 && !occupied[l.id]; });
      if (open) { out.push({ id: open.id, label: open.label || m.label }); return; }
      out.push({
        id: 'unavailable:' + m.id, label: m.label + WI_LOCATION_UNAVAILABLE, disabled: true,
        note: blockedLocationNote(m.ids, ((wiOffer && wiOffer.occupancy) || []))
      });
    });
    return out;
  }
  function viewForWisconsinLocation(id) {
    const loc = (wiOffer.locations || []).find(l => l.id === id);
    if (loc && loc.view) return loc.view;
    const geo = WI_LOCATION_GEO[id];
    return (geo && geo.view) || 'front';
  }
  // Display hangers come from Shopify product media (Liquid data-img-src /
  // image_url on the view pills). WI attach writes the personalization blob
  // without views.imageUrl — do not synthesize public locked-studio GCS
  // URLs (those 403 after the bucket lock). Leftover views.side 3/4 shots
  // are not location views.
  // Apple-style empty state (owner call 2026-09-09). The plate used to paint a
  // sample "NOBLE 37", which reads as somebody's real name and number; it now
  // shows the PROMPT on the name line only — no sample number, no number line —
  // and the first keystroke switches the plate to typed values alone. The fields
  // are labelled "Name" / "Number" (the blob's legacy "Last Name" reads like a
  // checkout form) and both placeholders read the prompt in sentence case.
  // No prompt on the garment (Grant, 2026-09-10): the plate stays EMPTY until
  // the shopper types; the inputs carry the "Your personalization" placeholder.
  // 2026-10-02 (Grant, phone): no label rows in hanger mode — the
  // placeholder IS the field name ("Name" / "Number"), one row per field.
  const WI_FIELD_LABELS = { name: 'Name', number: 'Number' };
  // Either one is enough (Grant, iPhone pass 2026-10-02), unless the store's mode
  // leaves only one.
  const WI_FIELD_PLACEHOLDERS = MODE_COPY.placeholders;
  // Hanger mode only. Zone-card (non-hanger) products keep their blob labels.
  function wisconsinFieldLabel(field) {
    if (!wisconsinActive()) return field.label;
    return WI_FIELD_LABELS[field.id] || field.label;
  }
  function wisconsinFieldPlaceholder(field) {
    return wisconsinActive() ? (WI_FIELD_PLACEHOLDERS[field.id] || field.label || '') : (field.placeholder || '');
  }
  function isLeftoverSideUrl(url) {
    const s = String(url || '').toLowerCase();
    if (!s) return true;
    if (/(?:^|\/)side\.(?:png|jpe?g|webp)(?:$|[?#])/.test(s)) return true;
    return false;
  }
  function isLockedStudioHangerUrl(url) {
    return /(?:https:\/\/storage\.googleapis\.com\/|gs:\/\/)ghostfit-locked-studio-[^/]+\/hangers\//i.test(String(url || ''));
  }
  function shopifyHangerSrc(url) {
    const s = String(url || '');
    if (!s || isLeftoverSideUrl(s) || isLockedStudioHangerUrl(s)) return '';
    return s;
  }
  function wisconsinIsJogger() {
    const classId = (wiOffer && wiOffer.classId) || (verifiedWi && verifiedWi.classId) || '';
    if (classId === 'jogger') return true;
    return /jogger/.test(String(productHandle || ''));
  }
  function ensureWisconsinViewPills() {
    if (!wisconsinActive() || !previewRoot) return;
    let host = previewRoot.querySelector('.gf-pz-pills');
    if (!host) {
      host = document.createElement('div');
      host.className = 'gf-pz-pills';
      host.setAttribute('role', 'tablist');
      const wrap = previewRoot.querySelector('.gf-pz-preview') || previewRoot;
      wrap.appendChild(host);
    }
    const existing = Array.from(host.querySelectorAll('.pd-thumb'));
    const byView = {};
    existing.forEach(function (t, i) {
      const v = ((t.dataset && t.dataset.view) || '').toLowerCase();
      if (!v || v === 'side') return;
      if (!byView[v]) byView[v] = t;
      if (i === 0 && !byView.front && v === 'front') byView.front = t;
    });
    const fallbackSrc = shopifyHangerSrc(
      (mainImg && mainImg.getAttribute('src'))
      || (byView.front && byView.front.dataset.imgSrc)
      || (existing[0] && existing[0].dataset.view !== 'side' && existing[0].dataset.imgSrc)
      || ''
    );
    const jogger = wisconsinIsJogger();
    // Every PRODUCT view the gallery carries stays a pill — front, back, left
    // sleeve, right sleeve — whether or not a location is open there (Grant,
    // 2026-09-10: the PDP showed four views but the modal only two). A pill
    // whose view has no open location just shows the hanger; the Location
    // menu lists that location as unavailable.
    const specs = (jogger
      ? WI_VIEWS.filter(function (s) { return s.id === 'front' || s.id === 'back'; })
      : WI_VIEWS
    ).filter(function (spec) {
      if (spec.id === 'front') return true;
      if (spec.id === 'back') return true;
      return !!shopifyHangerSrc(byView[spec.id] && byView[spec.id].dataset.imgSrc);
    });
    host.replaceChildren();
    specs.forEach(function (spec) {
      const prior = byView[spec.id];
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pd-thumb';
      btn.dataset.view = spec.id;
      btn.textContent = spec.label;
      const sleeve = spec.id === 'left-side' || spec.id === 'right-side';
      const priorSrc = shopifyHangerSrc(prior && prior.dataset.imgSrc);
      // Liquid data-img-src for every view, including back and sleeves.
      // Empty blob / missing thumb: no public GCS fallback.
      const src = sleeve
        ? priorSrc
        : (priorSrc || (spec.id === 'front' ? fallbackSrc : ''));
      if (src) btn.dataset.imgSrc = src;
      host.appendChild(btn);
    });
    thumbs = Array.from(host.querySelectorAll('.pd-thumb'));
  }
  if (wisconsinActive()) ensureWisconsinViewPills();

  // -------------------------------------------------------------------
  // Per-zone state. Single-zone products auto-enable (matches the prior
  // single-zone UX). Multi-zone products start with every zone disabled —
  // the customer toggles them on individually.
  // -------------------------------------------------------------------
  // The four ink colors every personalized product offers: the school's
  // primary + secondary (resolved from the school-colors blob) plus black and
  // white. Forced here so the chooser shows even when a template ships a single
  // ink, and so a stale/off-palette default token can't strand the preview.
  // Every personalized product hides the inks in the garment's own colour
  // family (Grant 2026-09-25: "we essentially don't want a blue on blue") —
  // gold on a gold hoodie, navy/royal/columbia on any blue, white on ash,
  // black on charcoal. The rule is gf-ink-contrast.js, a byte copy of
  // personalization/lib/ink-contrast.js that orderwebhook also runs to refuse a
  // crafted cart. At least one ink always stays.
  const PERS_INK_CHOICES_ALL = ['school-primary', 'school-secondary', 'black', 'white'];
  const PERS_INK_CHOICES = garmentSafeInks(PERS_INK_CHOICES_ALL);

  // The garment this product IS, by colour name: Liquid injects the product's
  // theme.sibling_color (else its colour tag) on #ghostfit-school-colors. The
  // blob's create-time garmentColor is only a last resort — it carried the
  // Wisconsin catalog's colour onto other stores' products of the same style.
  function personalizationGarment() {
    const injected = (schoolColors && schoolColors.garment) || {};
    const pdp = readGarmentFromPdp();
    const blob = (wiOffer && wiOffer.garmentColor) || config.garmentColor || {};
    return {
      name: injected.name || pdp.name || blob.name || '',
      hex: injected.hex || pdp.hex || ''
    };
  }
  function garmentSafeInks(choices) {
    const Ink = window.GfInkContrast;
    if (!Ink || typeof Ink.filterInks !== 'function') {
      // gf-ink-contrast.js did not load: keep the old hanger-only filter.
      return wisconsinActive() ? filterWisconsinInks(choices) : choices;
    }
    const garmentHex = Ink.resolveGarmentHex(personalizationGarment());
    const allowed = Ink.filterInks(choices.map(function (id) { return { id: id, hex: resolveColor(id) }; }), garmentHex);
    return dedupeWisconsinInks(allowed);
  }

  // The preview calibration for one offered location: its view and approved
  // print box. The form's zone takes it for the location being edited; every
  // other filled location gets its own preview group from it (#1123).
  function hangerCalibrationFor(loc) {
    const classId = wiOffer.classId || (verifiedWi && verifiedWi.classId);
    const stamped = wisconsinLocationRecord(loc.id, classId);
    const box = locationPrintBox(loc, classId);
    return {
      view: (stamped && stamped.view) || loc.view,
      viewImageIndex: loc.viewImageIndex == null ? null : loc.viewImageIndex,
      mockupAnchor: { box: Object.assign({}, box) },
      fieldLayout: loc.fieldLayout || (stamped && stamped.fieldLayout)
    };
  }
  function applyWisconsinLocationToZone(zone) {
    if (!wisconsinActive()) return zone;
    const loc = (wiOffer.locations || []).find(l => l.id === wiLocationId) || wiOffer.locations[0];
    if (!loc) return zone;
    zone.label = loc.label;
    zone.calibration = hangerCalibrationFor(loc);
    return zone;
  }
  // Hanger mode limits (Grant, 2026-09-10): a number can be three digits and a
  // last name is not counted at the shopper — the plate and the print both fit
  // text to the box width, so a long surname shrinks rather than truncates.
  // 20 characters is the silent hard stop; no counter is shown.
  const WI_FIELD_LIMITS = { name: 20, number: 3 };
  if (wisconsinActive()) {
    zones.forEach(function (z) {
      ((z.template && z.template.fields) || []).forEach(function (f) {
        if (WI_FIELD_LIMITS[f.id]) f.maxChars = WI_FIELD_LIMITS[f.id];
      });
    });
  }
  if (wisconsinActive() && zones[0]) applyWisconsinLocationToZone(zones[0]);
  // Once, here: every later read of a zone's fields (inputs, preview, validation,
  // cart) uses this list.
  zones.forEach(function (z) { z.template.fields = fieldsForMode(z.template.fields, STORE_MODE); });

  const zoneStates = zones.map(zone => ({
    zoneId: zone.id,
    zone: zone,
    enabled: !isMultiZone || autoEnableZones,  // single-zone or modal: pre-enabled
    values: {},
    font: resolvePreviewFont(zone),
    inkColor: pickWisconsinInk(zone),
    placeholderMap: buildPlaceholderMap(zone.template.fields),
    targetImageIndex: viewIndexForZone(zone)
  }));

  let activeImageIndex = 0;

  // The personalization preview shows ONLY the views that matter: the front
  // plus each zone's target view. Model / lifestyle / detail shots are hidden
  // and matched pills are labeled by their view (product call 2026-07-09).
  // Scoped to the modal (previewRoot) — the page gallery is never touched.
  // 2026-09-08 (Grant): every PRODUCT view stays visible — front, back, left
  // sleeve, right sleeve — even when it carries no zone. Only unlabeled media
  // (model / lifestyle / detail shots, no data-view) are hidden.
  if (previewRoot && thumbs.length && !wisconsinActive()) {
    const zoneTargets = new Set(zoneStates.map(zs => zs.targetImageIndex));
    thumbs.forEach((t, i) => {
      const tv = ((t.dataset && t.dataset.view) || '').toLowerCase();
      if (i !== 0 && !zoneTargets.has(i) && !tv) {
        t.hidden = true;
        t.style.display = 'none';
      }
    });
    thumbs.forEach((t, i) => {
      const tv = ((t.dataset && t.dataset.view) || '').toLowerCase();
      const zs = zoneStates.find(z => z.targetImageIndex === i);
      const v = zs ? String((zs.zone.calibration && zs.zone.calibration.view) || '').toLowerCase() : tv;
      if (!v) return;
      t.textContent = prettySideLabel(v);
    });
  }

  // -------------------------------------------------------------------
  // Utility helpers
  // -------------------------------------------------------------------
  function parsePriceCents(str) {
    if (!str) return null;
    const m = str.replace(/[, ]/g, '').match(/(\d+)(?:\.(\d{1,2}))?/);
    if (!m) return null;
    return (parseInt(m[1], 10) || 0) * 100 + (m[2] ? parseInt((m[2] + '00').slice(0, 2), 10) : 0);
  }
  // Re-use the shop's money format from an existing string ("$40.00") with a
  // new cents value, so this file never hardcodes a currency symbol.
  function formatMoneyLike(sample, cents) {
    return String(sample || '$0.00').replace(/[\d.,]+/, (cents / 100).toFixed(2));
  }
  function prettyFontName(f) {
    return f.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  }
  function prettyInkName(c) {
    if (c === 'school-primary') return 'School color';
    if (c === 'school-secondary') return 'Secondary';
    if (c === 'black') return 'Black';
    if (c === 'white') return 'White';
    return c.replace(/\b\w/g, x => x.toUpperCase());
  }
  function prettyViewLabel(view) {
    if (!view) return 'Front';
    return view.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  }
  // left-side / left-sleeve → "Left sleeve"; right-side → "Right sleeve"; else pretty.
  function prettySideLabel(view) {
    const v = String(view || '').toLowerCase();
    if (v.indexOf('side') !== -1 || v.indexOf('sleeve') !== -1) {
      if (v.indexOf('right') !== -1) return 'Right sleeve';
      if (v.indexOf('left') !== -1) return 'Left sleeve';
      return 'Sleeve';
    }
    return prettyViewLabel(v);
  }
  function resolveColor(name) {
    // The last-ditch fallback stays NEUTRAL off the test stores: a store with no
    // school colours must not print Wisconsin cardinal on its plate.
    if (name === 'school-primary') return (wiOffer && wiOffer.schoolColors && wiOffer.schoolColors.primary) || schoolColors.primary || (wiStoreFlag ? WI_TEST_SCHOOL_COLORS.primary : '#000000');
    if (name === 'school-secondary') return (wiOffer && wiOffer.schoolColors && wiOffer.schoolColors.secondary) || schoolColors.secondary || (wiStoreFlag ? WI_TEST_SCHOOL_COLORS.secondary : '#FFFFFF');
    if (name === 'black') return '#000000';
    if (name === 'white') return '#FFFFFF';
    return name;
  }
  function parseHexRgb(hex) {
    const h = String(hex || '').replace('#', '');
    if (!/^[0-9a-fA-F]{6}$/.test(h)) return null;
    return { r: parseInt(h.slice(0, 2), 16), g: parseInt(h.slice(2, 4), 16), b: parseInt(h.slice(4, 6), 16) };
  }
  function hexNearlySame(a, b) {
    const A = parseHexRgb(a);
    const B = parseHexRgb(b);
    if (!A || !B) return false;
    const dr = A.r - B.r, dg = A.g - B.g, db = A.b - B.b;
    return Math.sqrt(dr * dr + dg * dg + db * db) <= 64;
  }
  function normalizeInkHex(hex) {
    return String(hex || '').replace('#', '').toUpperCase();
  }
  function dedupeWisconsinInks(choices) {
    const rank = { white: 3, black: 3, 'school-primary': 2, 'school-secondary': 1 };
    const bestByHex = {};
    (choices || []).forEach(function (id) {
      const hex = normalizeInkHex(resolveColor(id));
      if (!hex) return;
      const prev = bestByHex[hex];
      if (!prev || (rank[id] || 0) > (rank[prev] || 0)) bestByHex[hex] = id;
    });
    const winners = {};
    Object.keys(bestByHex).forEach(function (hex) { winners[bestByHex[hex]] = true; });
    const out = [];
    (choices || []).forEach(function (id) {
      if (!winners[id]) return;
      winners[id] = false;
      out.push(id);
    });
    return out;
  }
  function filterWisconsinInks(choices) {
    let list = (Array.isArray(wiOffer && wiOffer.ink) && wiOffer.ink.length)
      ? wiOffer.ink.slice()
      : (choices || []).slice();
    const garmentHex = wiOffer && wiOffer.garmentColor && wiOffer.garmentColor.hex;
    const family = String((wiOffer && wiOffer.garmentColor && wiOffer.garmentColor.family) || '').toLowerCase();
    const hide = (id) => {
      if (id === 'black' && family.indexOf('black') !== -1 && family.indexOf('anthracite') === -1) return true;
      if (id === 'white' && family.indexOf('white') !== -1) return true;
      if (id === 'school-secondary' && family.indexOf('white') !== -1) return true;
      if (id === 'school-primary' && /red|cardinal/.test(family)) return true;
      return !!(garmentHex && hexNearlySame(resolveColor(id), garmentHex));
    };
    if (!(Array.isArray(wiOffer && wiOffer.ink) && wiOffer.ink.length)) {
      const filtered = list.filter(id => !hide(id));
      list = filtered.length ? filtered : list;
    }
    return dedupeWisconsinInks(list);
  }
  function pickWisconsinInk(zone) {
    const preferred = zone && zone.template && zone.template.defaultInkColor;
    if (PERS_INK_CHOICES.indexOf(preferred) !== -1) return preferred;
    return PERS_INK_CHOICES[0] || 'school-primary';
  }
  // typeId: a location's own type (preview groups for the locations not being
  // edited); defaults to the type in the form.
  function wisconsinVisibleFields(typeId) {
    if (!wisconsinActive()) return null;
    const id = typeId || wiType;
    const t = (wiOffer.types || []).find(x => x.id === id);
    return (t && t.fields) || ['name', 'number'];
  }
  function currentWisconsinLocation() {
    if (!wisconsinActive()) return null;
    return (wiOffer.locations || []).find(l => l.id === wiLocationId) || wiOffer.locations[0] || null;
  }
  function isLightColor(hex) {
    if (!hex || hex[0] !== '#') return false;
    const h = hex.replace('#', '');
    const r = parseInt(h.slice(0, 2), 16);
    const g = parseInt(h.slice(2, 4), 16);
    const b = parseInt(h.slice(4, 6), 16);
    return (0.2126 * r + 0.7152 * g + 0.0722 * b) > 170;
  }
  function viewIndexForZone(zone) {
    const cal = zone.calibration;
    // Resolve by VIEW first: thumbs carry data-view from media alts
    // ("front" / "back" / "left sleeve" / "right sleeve"). Leftover generate
    // "side" 3/4 shots are not location views. The calibrated viewImageIndex
    // was authored against older galleries that still had a 3/4 "side" shot.
    const view = cal && cal.view ? String(cal.view).toLowerCase() : '';
    if (view && thumbs.length) {
      const aliases = view === 'left-side' ? ['left-side', 'left-sleeve']
        : view === 'right-side' ? ['right-side', 'right-sleeve']
        : [view];
      const idx = thumbs.findIndex(t => {
        const tv = ((t.dataset && t.dataset.view) || '').toLowerCase();
        if (!tv) return false;
        if (aliases.indexOf(tv) !== -1) return true;
        if (wisconsinActive()) return false;
        // Loose "side" fallback stays side-specific: a left-side zone never
        // lands on the right-sleeve photo now that both sleeves ship.
        const sideOf = (x) => (x.indexOf('right') !== -1 ? 'right' : (x.indexOf('left') !== -1 ? 'left' : ''));
        return tv.indexOf('side') !== -1 && view.indexOf('side') !== -1 && sideOf(tv) === sideOf(view);
      });
      if (idx !== -1) return idx;
    }
    // Wisconsin: never use stale viewImageIndex (assumes [front,back,LS,RS]).
    if (wisconsinActive()) return -1;
    return (cal && typeof cal.viewImageIndex === 'number') ? cal.viewImageIndex : 0;
  }
  function buildPlaceholderMap(fields) {
    const out = {};
    for (const f of fields) out[f.id] = f.placeholder || f.label || '';
    return out;
  }
  function zoneHasEnteredValues(zs) {
    return Object.values(zs.values).some(v => v && v.trim());
  }
  function locationAddonCents() {
    if (isGhostFitHouseBrand()) return 0;
    // The blob's contract first (pricing.perLocation), the WI offer next, $10 last.
    const per = config && config.pricing && config.pricing.perLocation != null
      ? config.pricing.perLocation
      : ((wiOffer && wiOffer.addon) || 10);
    return Math.round(Number(per) * 100);
  }
  function wisconsinFieldsForType(typeId) {
    const t = ((wiOffer && wiOffer.types) || []).find(x => x.id === typeId);
    return (t && t.fields) || ['name', 'number'];
  }
  // -------------------------------------------------------------------
  // Multi-location (#1123, Grant 2026-10-02). A shopper fills any number of
  // the open locations, each with its OWN type, text and ink. The form edits
  // one location at a time (zoneStates[0]); every location's choices live in
  // wiStamps[id] = { type, values, ink }. These four are pure (no engine
  // state) so the theme tests run them, and the cart properties they write
  // are the ones orderwebhook's parser reads back per zone.
  // -------------------------------------------------------------------
  // Locations with something typed, in offer order, values limited to the
  // fields the location's type shows (a name left behind on a number-only
  // location is never sold).
  function filledHangerLocations(locations, stamps, fieldsForType) {
    const out = [];
    const seen = {};
    (locations || []).forEach(function (loc) {
      if (!loc || !loc.id || seen[loc.id]) return;
      const stamp = stamps && stamps[loc.id];
      if (!stamp || !stamp.values) return;
      const values = {};
      fieldsForType(stamp.type).forEach(function (k) {
        const v = String(stamp.values[k] || '');
        if (v.trim()) values[k] = v;
      });
      if (!Object.keys(values).length) return;
      seen[loc.id] = true;
      out.push({ id: loc.id, type: stamp.type, values: values, ink: stamp.ink || null });
    });
    return out;
  }
  // "NOBLE 37 on Back · White, 37 on Left Sleeve · Secondary"
  function hangerSummary(filled, labelFor, inkNameFor) {
    return (filled || []).map(function (f) {
      const name = String((f.values && f.values.name) || '').trim().toUpperCase();
      const num = String((f.values && f.values.number) || '').trim();
      const label = labelFor(f.id);
      const ink = f.ink ? inkNameFor(f.ink) : '';
      return [name, num].filter(Boolean).join(' ') + (label ? ' on ' + label : '') + (ink ? ' · ' + ink : '');
    }).join(', ');
  }
  // Cart properties as [name, value] pairs: one _pers_zone_<id>_* group per
  // filled location (downstream the zone id IS the location id), each with its
  // own ink, then the legacy flat keys mirroring the FIRST filled location.
  // ctx = { templateId, configId, font, perLocationCents, inkHex(id), uppercase(fieldId), reviewed, letterHeight }
  function hangerCartProperties(filled, ctx) {
    const out = [];
    const add = function (k, v) { out.push([k, v]); };
    const per = (ctx.perLocationCents / 100).toFixed(2);
    const addFields = function (prefix, loc) {
      Object.keys(loc.values).forEach(function (k) {
        const v = String(loc.values[k]);
        add(prefix + k, ctx.uppercase(k) ? v.toUpperCase() : v);
      });
    };
    (filled || []).forEach(function (loc) {
      const p = '_pers_zone_' + loc.id + '_';
      add(p + 'template', ctx.templateId);
      add(p + 'type', loc.type);
      add(p + 'location', loc.id);
      addFields(p + 'field_', loc);
      add(p + 'font', ctx.font);
      add(p + 'ink', ctx.inkHex(loc.ink));
      add(p + 'addon', per);
    });
    if (!filled || !filled.length) return out;
    // Which review wording the buyer ticked (only ever on a filled line: this
    // prefix makes a line count as personalized downstream). A constant, so
    // identical items still merge into one cart line.
    if (ctx.reviewed) add('_personalization_review', ctx.reviewed);
    // The preview drew this line at the fixed letter height
    // (GfFixedLetterHeight), so print must too: orderwebhook sends the fixed
    // letter height only for a line that carries this constant. A line from
    // an older preview prints the way that preview drew it.
    if (ctx.letterHeight) add('_personalization_letter_height', ctx.letterHeight);
    add('_personalization_locations', String(filled.length));
    if (ctx.perLocationCents > 0) add('_personalization_total_addon', (ctx.perLocationCents * filled.length / 100).toFixed(2));
    const first = filled[0];
    add('_personalization_template', ctx.templateId);
    if (ctx.configId) add('_personalization_config_id', ctx.configId);
    add('_personalization_type', first.type);
    add('_personalization_location', first.id);
    addFields('_personalization_field_', first);
    add('_personalization_font', ctx.font);
    add('_personalization_ink_color', ctx.inkHex(first.ink));
    add('_personalization_addon', per);
    return out;
  }
  // Review step (the required spelling tick, Grant 2026-11-02). Which photos it
  // shows: front and back always, a sleeve only with something on it, filled
  // views first. A spot on a view with no photo is left to its text row.
  // thumbViews = [{ view, label, src, index }]; spotIndexes = photo index of each
  // filled spot.
  function reviewViewList(thumbViews, spotIndexes) {
    const filled = spotIndexes || [];
    const seen = {};
    const views = (thumbViews || []).filter(function (t) {
      if (!t || !t.src || seen[t.view]) return false;
      if (filled.indexOf(t.index) === -1 && t.view !== 'front' && t.view !== 'back') return false;
      seen[t.view] = true;
      return true;
    });
    const isFilled = function (t) { return filled.indexOf(t.index) !== -1; };
    return views.filter(isFilled).concat(views.filter(function (t) { return !isFilled(t); }));
  }
  // One row per filled spot, in the exact text the cart receives
  // (hangerCartProperties cases each field the same way).
  function reviewSpotRows(filled, labelFor, addonCents, upper) {
    return (filled || []).map(function (f) {
      const values = f.values || {};
      const text = Object.keys(values).map(function (k) {
        const v = String(values[k]);
        return upper(k) ? v.toUpperCase() : v;
      }).join(' ');
      return { id: f.id, label: labelFor(f.id) || '', text: text, addonCents: addonCents, ink: f.ink || null };
    });
  }
  // A preview group copied into the review. It may come from a hidden photo, so
  // clear its display, and its clip keeps working only under a unique id: a
  // duplicate id resolves to the first match, possibly inside a hidden original.
  function prepareReviewClone(copy, index) {
    copy.style.display = '';
    copy.removeAttribute('data-zone-id');
    const clip = copy.querySelector('defs [id]');
    if (!clip) return copy;
    const id = 'gf-pz-review-' + index + '-' + clip.getAttribute('id');
    clip.setAttribute('id', id);
    copy.setAttribute('clip-path', 'url(#' + id + ')');
    return copy;
  }
  // Grant's iPhone test (2026-10-02): a greyed chip must say WHY. The blob's
  // occupancy carries reason + label ('team-logo' / 'brand-mark' "Nike swoosh"
  // / 'overlap'); an overlap is always an overlap of a logo.
  function blockedLocationNote(ids, occupancy) {
    const occ = (occupancy || []).filter(function (o) { return o && ids.indexOf(o.id) !== -1; });
    const own = occ.find(function (o) { return o.reason && o.reason !== 'overlap'; });
    if (own) return own.reason === 'team-logo' ? 'Team logo' : (own.label || 'Logo');
    if (occ.some(function (o) { return o.reason === 'overlap'; })) return 'Team logo';
    return 'Not available';
  }
  // What a filled chip shows under its name, so the shopper sees the text was
  // kept when they tap another location: "NOBLE 37".
  function savedLocationText(filled) {
    const v = (filled && filled.values) || {};
    return [String(v.name || '').trim().toUpperCase(), String(v.number || '').trim()].filter(Boolean).join(' ');
  }
  // Keyboard open on a phone: the preview becomes a short strip zoomed onto
  // the print box being edited (box = fractions of the 1000x1200 hanger, the
  // same frame as the photo). fx/fy = box centre; zoom makes the box ~70% of
  // the strip's height, capped so a narrow sleeve box stays sharp.
  function previewFocusFor(box) {
    if (!box || !(box.w > 0) || !(box.h > 0)) return null;
    const pct = function (n) { return (Math.round(n * 10000) / 100).toFixed(2) + '%'; };
    return {
      fx: pct(box.x + box.w / 2),
      fy: pct(box.y + box.h / 2),
      zoom: Math.min(5, Math.max(1, 0.7 / box.h)).toFixed(2)
    };
  }
  // No Type picker (Grant 2026-10-02: fewest controls on a phone). The type
  // is what the shopper typed: a name, a number, or both. '' = nothing yet.
  function deriveHangerType(values) {
    const v = values || {};
    const hasName = !!String(v.name || '').trim();
    const hasNumber = !!String(v.number || '').trim();
    if (hasName && hasNumber) return 'name-number';
    if (hasName) return 'name';
    if (hasNumber) return 'number';
    return '';
  }
  // A location opened for the first time starts with the ink the shopper last
  // picked, if this garment offers it (Grant 2026-10-02).
  function inkForNewLocation(lastInk, allowed) {
    if (!allowed || !allowed.length) return lastInk || 'school-primary';
    return allowed.indexOf(lastInk) !== -1 ? lastInk : allowed[0];
  }
  let lastPickedInk = '';

  function hangerDefaultType() {
    return (wiOffer && wiOffer.defaultType) || 'name-number';
  }
  function rememberWisconsinStamp() {
    if (!wisconsinActive() || !wiLocationId || !zoneStates[0]) return;
    const values = Object.assign({}, zoneStates[0].values);
    wiType = deriveHangerType(values) || hangerDefaultType();
    wiStamps[wiLocationId] = { type: wiType, values: values, ink: zoneStates[0].inkColor };
  }
  function restoreWisconsinStamp() {
    if (!wisconsinActive() || !wiLocationId || !zoneStates[0]) return;
    const zs = zoneStates[0];
    const saved = wiStamps[wiLocationId] || {
      type: hangerDefaultType(),
      values: {},
      ink: inkForNewLocation(lastPickedInk || zs.inkColor, PERS_INK_CHOICES)
    };
    zs.inkColor = PERS_INK_CHOICES.indexOf(saved.ink) !== -1 ? saved.ink : inkForNewLocation(saved.ink, PERS_INK_CHOICES);
    syncInkSwatches(zs);
    wiType = deriveHangerType(saved.values) || hangerDefaultType();
    for (const field of zs.zone.template.fields) {
      const next = (saved.values && saved.values[field.id]) || '';
      zs.values[field.id] = next;
      const input = zonesContainer && zonesContainer.querySelector('input[data-zone-field="' + cssEscape(zs.zoneId + ':' + field.id) + '"]');
      if (input) input.value = next;
      const counter = zonesContainer && zonesContainer.querySelector('[data-counter-for="' + cssEscape(zs.zoneId + ':' + field.id) + '"]');
      if (counter) {
        counter.textContent = next.length + ' / ' + field.maxChars;
        counter.classList.toggle('is-full', field.maxChars > 0 && next.length === field.maxChars);
      }
    }
  }
  // Every location the shopper actually filled, in the offer's order.
  // Each entry: { id, type, values, ink }.
  function wisconsinFilledLocations() {
    if (!wisconsinActive()) return [];
    rememberWisconsinStamp();
    return filledHangerLocations((wiOffer && wiOffer.locations) || [], wiStamps, wisconsinFieldsForType);
  }
  function wisconsinLocationLabel(id) {
    const loc = ((wiOffer && wiOffer.locations) || []).find(function (l) { return l.id === id; }) || {};
    return loc.label || '';
  }
  function wisconsinPersonalizationSummary() {
    if (!wisconsinActive()) return '';
    // No ink names (Grant: drop "School color" wording); the swatch shows it.
    return hangerSummary(wisconsinFilledLocations(), wisconsinLocationLabel, function () { return ''; });
  }
  function wisconsinFilledLocationCount() {
    if (!wisconsinActive()) {
      return zoneStates.filter(zs => zs.enabled && zoneHasEnteredValues(zs)).length;
    }
    return wisconsinFilledLocations().length;
  }
  function zoneAddonCents(zs) {
    if (isGhostFitHouseBrand()) return 0;
    if (wisconsinActive()) return locationAddonCents() * Math.max(wisconsinFilledLocationCount(), zoneHasEnteredValues(zs) ? 1 : 0);
    return Math.round((zs.zone.template.pricing.addon || 0) * 100);
  }
  function hangerFieldUppercase(fieldId) {
    const fieldDef = zoneStates[0] && zoneStates[0].zone.template.fields.find(f => f.id === fieldId);
    return !!(fieldDef && fieldDef.uppercase);
  }
  function zoneLabel(zs) {
    return zs.zone.label || prettyViewLabel(zs.zone.calibration && zs.zone.calibration.view) + ' personalization';
  }

  // -------------------------------------------------------------------
  // Card rendering
  // -------------------------------------------------------------------
  function buildAllCards() {
    zonesContainer.replaceChildren();
    for (const zs of zoneStates) {
      zonesContainer.appendChild(buildZoneCard(zs));
    }
  }

  function buildZoneCard(zs) {
    const card = document.createElement('div');
    card.className = 'pd-pers-zone';
    card.dataset.zoneId = zs.zoneId;
    card.dataset.viewIndex = zs.targetImageIndex;
    if (zs.enabled) card.classList.add('is-enabled');

    // Header: title + addon + (for multi-zone) toggle
    const header = document.createElement('header');
    header.className = 'pd-pers-zone-header';

    if (isMultiZone && !autoEnableZones) {
      const toggleLabel = document.createElement('label');
      toggleLabel.className = 'pd-pers-zone-toggle';
      const toggle = document.createElement('input');
      toggle.type = 'checkbox';
      toggle.dataset.zoneToggle = zs.zoneId;
      toggle.checked = zs.enabled;
      const title = document.createElement('strong');
      title.textContent = zoneLabel(zs);
      toggleLabel.appendChild(toggle);
      toggleLabel.appendChild(title);
      header.appendChild(toggleLabel);
    } else {
      const title = document.createElement('strong');
      title.className = 'pd-pers-zone-title';
      title.textContent = zoneLabel(zs);
      header.appendChild(title);
    }

    const addon = document.createElement('span');
    addon.className = 'pd-pers-zone-addon';
    addon.dataset.zoneAddonFor = zs.zoneId;
    const addonCents = wisconsinActive() ? locationAddonCents() : zoneAddonCents(zs);
    addon.textContent = addonCents ? '+' + formatMoneyLike(ctaPrice && ctaPrice.textContent, addonCents) : 'Included';
    header.appendChild(addon);
    card.appendChild(header);

    // Body — hidden for disabled zones (multi-zone). Always visible for single-zone.
    const body = document.createElement('div');
    body.className = 'pd-pers-zone-body';
    if (!zs.enabled) body.hidden = true;

    // View hint inside the card — shown when this zone is enabled but the
    // active image isn't this zone's view.
    const viewHint = document.createElement('p');
    viewHint.className = 'pd-pers-zone-view-hint';
    viewHint.dataset.zoneViewHintFor = zs.zoneId;
    const viewLabel = prettyViewLabel(zs.zone.calibration && zs.zone.calibration.view);
    const hintIcon = document.createElementNS(SVG_NS, 'svg');
    hintIcon.setAttribute('width', '14');
    hintIcon.setAttribute('height', '14');
    hintIcon.setAttribute('viewBox', '0 0 24 24');
    hintIcon.setAttribute('fill', 'none');
    hintIcon.setAttribute('stroke', 'currentColor');
    hintIcon.setAttribute('stroke-width', '2');
    hintIcon.setAttribute('stroke-linecap', 'round');
    hintIcon.setAttribute('stroke-linejoin', 'round');
    hintIcon.setAttribute('aria-hidden', 'true');
    hintIcon.innerHTML = '<polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>';
    viewHint.appendChild(hintIcon);
    const hintText = document.createElement('span');
    hintText.innerHTML = 'Personalization prints on the <strong>' + escapeHtml(viewLabel) + '</strong>';
    viewHint.appendChild(hintText);
    body.appendChild(viewHint);

    // Fields container — inputs, font, ink for THIS zone
    const fields = document.createElement('div');
    fields.className = 'pd-pers-fields';
    fields.dataset.zoneFieldsFor = zs.zoneId;
    buildZoneFields(zs, fields);
    body.appendChild(fields);

    card.appendChild(body);
    return card;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  }

  // Location chips (#1123, Grant 2026-10-02) replace the Location <select>:
  // every garment location in one row, ✓ on the filled ones, the location
  // being edited selected. Taken locations stay listed but disabled, so the
  // shopper sees why the front is not on offer.
  // ONE guidance line above the chips, changing with what the shopper is doing
  // (Grant 2026-10-03: the step list, the chip sublabels and the card below
  // were three layers saying the same thing).
  // The ask names the spots that ARE open (Grant 2026-10-03: tell them what
  // they can pick, not just to pick): "Choose the back or right sleeve to
  // personalize." Labels come in chip order.
  function availableSpotsSentence(labels, what) {
    const spots = (labels || []).map(function (l) { return String(l).trim().toLowerCase(); }).filter(Boolean);
    if (!spots.length) return "Choose where you'd like your " + (what || 'name or number') + '.';
    let list = spots[0];
    if (spots.length === 2) list = spots[0] + ' or ' + spots[1];
    if (spots.length > 2) list = spots.slice(0, -1).join(', ') + ', or ' + spots[spots.length - 1];
    return 'Choose the ' + list + ' to personalize.';
  }
  // Open (decoratable) locations' labels, in chip order.
  function hangerOpenLabels() {
    return wisconsinLocationOptions().filter(function (o) { return !o.disabled; }).map(function (o) { return o.label; });
  }
  function hangerGuide(state) {
    if (state.awaiting) return { title: availableSpotsSentence(state.available, state.what), note: state.blocked || '' };
    const n = state.saved || 0;
    return {
      title: state.ask || 'Add a name, a number, or both.',
      note: n ? (n === 1 ? '1 location saved' : n + ' locations saved') + '. Tap another spot to add more.' : ''
    };
  }
  // Every open starts on the FRONT photo with no location picked (Grant
  // 2026-10-02): the shopper taps the location they want, then types. Until
  // then the inputs and swatches are inactive.
  let hangerAwaitingPick = false;
  // A spot that can't be decorated (Grant 2026-10-02): no Name / Number /
  // colours there, just an Apple-style ask and why.
  let hangerViewingChip = null; // the blocked chip being shown, else the front
  function blockedSpotSentence(where, why) {
    const spot = String(where || 'this spot').trim().toLowerCase();
    const reason = String(why || '').trim();
    if (reason === 'Team logo') return 'The ' + spot + ' has your team logo.';
    if (reason && reason !== 'Not available') return 'The ' + spot + ' has the ' + reason + '.';
    return 'The ' + spot + ' can\'t be personalized on this item.';
  }
  function setHangerFieldsActive(active) {
    zonesContainer.classList.toggle('is-awaiting-location', !active);
    zonesContainer.querySelectorAll('input[data-zone-field], .pd-pers-swatch').forEach(function (el) { el.disabled = !active; });
  }
  function startHangerView() {
    if (!wisconsinActive()) return;
    hangerAwaitingPick = true;
    hangerViewingChip = null;
    setHangerFieldsActive(false);
    syncLocationChips();
    const idx = thumbs.findIndex(t => ((t.dataset && t.dataset.view) || '').toLowerCase() === 'front');
    setActiveImage(idx !== -1 ? idx : 0);
  }
  function appendLocationChips(container) {
    const wrap = document.createElement('div');
    wrap.className = 'pd-pers-field pd-pers-field--full';
    const guide = document.createElement('div');
    guide.className = 'pd-pers-guide';
    guide.setAttribute('aria-live', 'polite');
    const guideTitle = document.createElement('p');
    guideTitle.className = 'pd-pers-guide-title';
    guideTitle.dataset.guideTitle = 'true';
    const guideNote = document.createElement('p');
    guideNote.className = 'pd-pers-guide-note';
    guideNote.dataset.guideNote = 'true';
    guide.appendChild(guideTitle);
    guide.appendChild(guideNote);
    wrap.appendChild(guide);
    const row = document.createElement('div');
    row.className = 'pd-pers-locs';
    row.setAttribute('role', 'group');
    row.setAttribute('aria-label', 'Personalization location');
    wisconsinLocationOptions().forEach(function (opt) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pd-pers-loc';
      btn.dataset.wiLocationChip = opt.id;
      // The location, and once filled what is SAVED on it ("✓ NOBLE 37").
      // A blocked spot's reason ("Team logo") is not a sublabel; the guidance
      // line says it when the spot is shown (data-blocked-note).
      const name = document.createElement('span');
      name.className = 'pd-pers-loc-name';
      name.textContent = opt.disabled ? opt.label.replace(WI_LOCATION_UNAVAILABLE, '') : opt.label;
      const note = document.createElement('span');
      note.className = 'pd-pers-loc-note';
      if (opt.disabled) {
        // Still tappable: it shows that view's photo (Grant wants to SEE the
        // front) and says why it can't be personalized. Never `disabled`.
        btn.dataset.blocked = 'true';
        btn.classList.add('is-blocked');
        btn.setAttribute('aria-disabled', 'true');
        btn.dataset.blockedNote = opt.note || 'Not available';
        btn.setAttribute('aria-label', name.textContent + ': ' + btn.dataset.blockedNote + '. View only');
      }
      btn.appendChild(name);
      btn.appendChild(note);
      row.appendChild(btn);
    });
    wrap.appendChild(row);
    container.appendChild(wrap);
  }
  // A blocked chip tapped: show that view's photo and say why (the team logo
  // or a brand mark prints there). Typing returns to the location being edited.
  const BLOCKED_CHIP_VIEW = { front: 'front', back: 'back', 'left-sleeve': 'left-side', 'right-sleeve': 'right-side' };
  function viewBlockedLocation(chip) {
    const menuId = String(chip.dataset.wiLocationChip || '').replace(/^unavailable:/, '');
    const view = BLOCKED_CHIP_VIEW[menuId];
    const idx = thumbs.findIndex(t => ((t.dataset && t.dataset.view) || '').toLowerCase() === view);
    // Nothing can be decorated here: put Name / Number / colours away until
    // the shopper picks a spot that can (tapping it resumes, even the one
    // they were on — switchHangerLocation honors hangerAwaitingPick).
    hangerAwaitingPick = true;
    hangerViewingChip = chip;
    setHangerFieldsActive(false);
    syncLocationChips();
    if (idx !== -1) setActiveImage(idx);
  }
  function syncLocationChips() {
    if (!zonesContainer) return;
    const filledList = wisconsinFilledLocations();
    const filled = {};
    filledList.forEach(function (f) { filled[f.id] = f; });
    zonesContainer.querySelectorAll('[data-wi-location-chip]').forEach(function (chip) {
      chip.classList.remove('is-viewing');
      if (chip.dataset.blocked) return;
      const id = chip.dataset.wiLocationChip;
      const active = !hangerAwaitingPick && id === wiLocationId;
      const savedText = savedLocationText(filled[id]);
      chip.classList.toggle('is-active', active);
      chip.classList.toggle('is-filled', !!filled[id]);
      chip.setAttribute('aria-pressed', active ? 'true' : 'false');
      const note = chip.querySelector('.pd-pers-loc-note');
      // ✓ rides on the saved line ("✓ NOBLE 37") so a long name like
      // "Right Sleeve" never wraps the tick onto a line of its own.
      if (note) note.textContent = savedText ? '✓ ' + savedText : '';
      const label = wisconsinLocationLabel(id) || chip.textContent;
      chip.setAttribute('aria-label', label + (savedText ? ', saved: ' + savedText : ''));
    });
    const frontChip = zonesContainer.querySelector('[data-wi-location-chip="unavailable:front"]');
    const viewed = hangerAwaitingPick ? (hangerViewingChip || frontChip) : null;
    if (viewed) viewed.classList.add('is-viewing');
    const nameEl = viewed && viewed.querySelector('.pd-pers-loc-name');
    const guide = hangerGuide({
      awaiting: hangerAwaitingPick,
      available: hangerOpenLabels(),
      what: MODE_COPY.what,
      ask: MODE_COPY.ask,
      blocked: viewed && viewed.dataset.blocked
        ? blockedSpotSentence(nameEl ? nameEl.textContent : '', viewed.dataset.blockedNote || '')
        : '',
      saved: filledList.length
    });
    const guideTitle = zonesContainer.querySelector('[data-guide-title]');
    const guideNote = zonesContainer.querySelector('[data-guide-note]');
    if (guideTitle) guideTitle.textContent = guide.title;
    if (guideNote) guideNote.textContent = guide.note;
    const inkLabel = zonesContainer.querySelector('[data-ink-label-for]');
    if (inkLabel) inkLabel.textContent = 'Color for ' + (wisconsinLocationLabel(wiLocationId) || 'this location');
  }
  // Mirror zs.inkColor onto its swatch row (after a location switch or restore).
  function syncInkSwatches(zs) {
    if (!zonesContainer || !zs) return;
    const row = zonesContainer.querySelector('[data-zone-swatches-for="' + cssEscape(zs.zoneId) + '"]');
    if (row) row.querySelectorAll('.pd-pers-swatch').forEach(s => s.setAttribute('aria-pressed', s.dataset.inkColor === zs.inkColor ? 'true' : 'false'));
    const currentName = zonesContainer.querySelector('[data-ink-current-for="' + cssEscape(zs.zoneId) + '"]');
    if (currentName) currentName.textContent = prettyInkName(zs.inkColor);
  }
  function switchHangerLocation(next) {
    if (!wisconsinActive() || !next) return;
    // The location loaded behind the front view still counts as a pick.
    if (next === wiLocationId && !hangerAwaitingPick) {
      // Same spot, but a view pill with no open location (Front under a logo)
      // can have left another photo up: put this spot's photo back.
      const zs = zoneStates[0];
      if (zs && zs.targetImageIndex >= 0 && activeImageIndex !== zs.targetImageIndex) setActiveImage(zs.targetImageIndex);
      return;
    }
    if (wisconsinOccupiedSet()[next]) return;
    if (!(wiOffer.locations || []).some(l => l.id === next)) return;
    if (next !== wiLocationId) {
      rememberWisconsinStamp();
      wiLocationId = next;
      restoreWisconsinStamp();
    }
    hangerAwaitingPick = false;
    setHangerFieldsActive(true);
    applyWisconsinLocationState();
    renderAllZonesSVG();
    updatePricing();
  }
  function applyWisconsinLocationState() {
    if (!wisconsinActive()) return;
    const loc = currentWisconsinLocation();
    if (!loc) return;
    const zs = zoneStates[0];
    if (!zs) return;
    applyWisconsinLocationToZone(zs.zone);
    zs.targetImageIndex = viewIndexForZone(zs.zone);
    const card = zonesContainer.querySelector('.pd-pers-zone');
    if (card) card.dataset.viewIndex = zs.targetImageIndex;
    syncLocationChips();
    // Keyboard-open zoom target (CSS uses it only while [data-compact]).
    const focus = previewFocusFor(zs.zone.calibration && zs.zone.calibration.mockupAnchor && zs.zone.calibration.mockupAnchor.box);
    if (previewRoot && focus) {
      previewRoot.style.setProperty('--gf-pz-fx', focus.fx);
      previewRoot.style.setProperty('--gf-pz-fy', focus.fy);
      previewRoot.style.setProperty('--gf-pz-zoom', focus.zoom);
    }
    if (activeImageIndex !== zs.targetImageIndex) setActiveImage(zs.targetImageIndex);
    else applyZoneVisibility(zs);
    updateZoneViewHints();
  }

  function buildZoneFields(zs, container) {
    const t = zs.zone.template;
    if (wisconsinActive()) {
      // No Type picker (Grant 2026-10-02): the type is whatever the shopper
      // types (deriveHangerType), so Name and Number are both always shown.
      appendLocationChips(container);
    }
    // Text/number inputs
    for (const field of t.fields) {
      const wrap = document.createElement('label');
      wrap.className = 'pd-pers-field' + (wisconsinActive() ? ' pd-pers-text' : '');
      // Hanger mode: the field's name is its placeholder (one row per field on
      // a phone). No visible character count: the limit is silent and the
      // plate fits whatever is typed (every counter reader null-checks).
      if (!wisconsinActive()) {
        const labelRow = document.createElement('div');
        labelRow.className = 'pd-pers-field-label';
        const labelText = document.createElement('span');
        labelText.textContent = wisconsinFieldLabel(field);
        labelRow.appendChild(labelText);
        const counter = document.createElement('span');
        counter.className = 'pd-pers-counter';
        counter.dataset.counterFor = zs.zoneId + ':' + field.id;
        counter.textContent = String(zs.values[field.id] || '').length + ' / ' + field.maxChars;
        labelRow.appendChild(counter);
        wrap.appendChild(labelRow);
      }

      const input = document.createElement('input');
      input.type = field.type === 'numeric' ? 'tel' : 'text';
      input.inputMode = field.type === 'numeric' ? 'numeric' : 'text';
      input.maxLength = field.maxChars;
      input.placeholder = wisconsinFieldPlaceholder(field);
      if (wisconsinActive()) input.setAttribute('aria-label', wisconsinFieldLabel(field));
      input.dataset.zoneField = zs.zoneId + ':' + field.id;
      input.value = zs.values[field.id] || '';
      if (field.type === 'numeric') input.pattern = '[0-9]*';
      if (field.uppercase) input.dataset.uppercase = 'true';
      input.autocomplete = 'off';
      input.spellcheck = false;
      wrap.appendChild(input);
      container.appendChild(wrap);
    }

    // Font (only if there's a choice)
    if (t.availableFonts.length > 1) {
      const wrap = document.createElement('label');
      wrap.className = 'pd-pers-field';
      const labelRow = document.createElement('div');
      labelRow.className = 'pd-pers-field-label';
      const labelText = document.createElement('span');
      labelText.textContent = 'Font';
      labelRow.appendChild(labelText);
      wrap.appendChild(labelRow);
      const sel = document.createElement('select');
      sel.dataset.zoneFont = zs.zoneId;
      for (const f of t.availableFonts) {
        const opt = document.createElement('option');
        opt.value = f;
        opt.selected = f === zs.font;
        opt.textContent = prettyFontName(f);
        sel.appendChild(opt);
      }
      wrap.appendChild(sel);
      container.appendChild(wrap);
    }

    // Ink swatches — always offer the four standard text colors (school
    // primary/secondary + black/white), regardless of the template's own list.
    if (PERS_INK_CHOICES.length > 1) {
      const wrap = document.createElement('div');
      wrap.className = 'pd-pers-field pd-pers-field--full pd-pers-ink';
      const labelRow = document.createElement('div');
      labelRow.className = 'pd-pers-field-label';
      const labelText = document.createElement('span');
      labelText.textContent = 'Color';
      // Hanger mode: ink is per location, so the label names the location
      // (syncLocationChips keeps it current).
      if (wisconsinActive()) {
        labelText.dataset.inkLabelFor = zs.zoneId;
        labelText.textContent = 'Color for ' + (wisconsinLocationLabel(wiLocationId) || 'this location');
      }
      labelRow.appendChild(labelText);
      const currentName = document.createElement('span');
      currentName.className = 'pd-pers-counter';
      currentName.dataset.inkCurrentFor = zs.zoneId;
      currentName.textContent = prettyInkName(zs.inkColor);
      // Hanger mode names no ink ("School color" read as a promise of the
      // school's exact colour; the swatch itself shows it).
      if (!wisconsinActive()) labelRow.appendChild(currentName);
      wrap.appendChild(labelRow);

      const row = document.createElement('div');
      row.className = 'pd-pers-swatches';
      row.setAttribute('role', 'radiogroup');
      row.setAttribute('aria-label', 'Color');
      row.dataset.zoneSwatchesFor = zs.zoneId;
      for (const c of PERS_INK_CHOICES) {
        const hex = resolveColor(c);
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pd-pers-swatch';
        btn.style.setProperty('--swatch-fill', hex);
        btn.style.setProperty('--swatch-tick-color', isLightColor(hex) ? '#0a0a0a' : '#ffffff');
        btn.dataset.inkColor = c;
        btn.setAttribute('aria-label', prettyInkName(c));
        btn.setAttribute('aria-pressed', c === zs.inkColor ? 'true' : 'false');
        const tickWrap = document.createElement('span');
        tickWrap.className = 'pd-pers-swatch-tick';
        const tickSvg = document.createElementNS(SVG_NS, 'svg');
        tickSvg.setAttribute('width', '14');
        tickSvg.setAttribute('height', '14');
        tickSvg.setAttribute('viewBox', '0 0 24 24');
        tickSvg.setAttribute('fill', 'none');
        tickSvg.setAttribute('stroke', 'currentColor');
        tickSvg.setAttribute('stroke-width', '3');
        tickSvg.setAttribute('stroke-linecap', 'round');
        tickSvg.setAttribute('stroke-linejoin', 'round');
        const tickPath = document.createElementNS(SVG_NS, 'polyline');
        tickPath.setAttribute('points', '20 6 9 17 4 12');
        tickSvg.appendChild(tickPath);
        tickWrap.appendChild(tickSvg);
        btn.appendChild(tickWrap);
        row.appendChild(btn);
      }
      wrap.appendChild(row);
      container.appendChild(wrap);
    }
  }

  // -------------------------------------------------------------------
  // SVG rendering — every zone renders into a dedicated <g>. Hidden when
  // the zone is disabled OR when the active image doesn't match the zone's
  // view. Mid-text changes only re-render the affected zone's <g>.
  // -------------------------------------------------------------------
  function renderZoneSVG(zs, opts) {
    const animateField = opts && opts.animateField;
    const Svg = window.GfSvg;

    // Find or create this zone's group inside the SVG
    let g = svg.querySelector('g[data-zone-id="' + cssEscape(zs.zoneId) + '"]');
    if (!g) {
      g = document.createElementNS(SVG_NS, 'g');
      g.setAttribute('data-zone-id', zs.zoneId);
      svg.appendChild(g);
    } else {
      while (g.firstChild) g.removeChild(g.firstChild);
    }

    const cal = zs.zone.calibration;
    const { box } = cal.mockupAnchor;
    // A preview group for a location NOT being edited carries its own type and
    // location id (renderHangerGhosts); the form's zone uses the globals.
    const typeId = zs.hangerType || wiType;
    const locationId = zs.hangerLocationId || wiLocationId;
    // Hanger stores: text is laid out in the print canvas's shape (4x5 sleeves,
    // 10x10 back) centred in the approved box, so the preview's proportions are
    // the print file's. The clip plate stays the approved box.
    const drawBox = wisconsinActive() ? printAspectBox(box, locationId) : box;
    const fontFamilyClass = 'gf-font-' + zs.font;
    const fill = resolveColor(zs.inkColor);

    let defs = null;
    function ensureDefs() {
      if (defs) return defs;
      defs = document.createElementNS(SVG_NS, 'defs');
      g.appendChild(defs);
      return defs;
    }

    const visibleIds = wisconsinVisibleFields(typeId);
    const activeFields = zs.zone.template.fields.filter(field => {
      if (visibleIds && visibleIds.indexOf(field.id) === -1) return false;
      const layout = cal.fieldLayout && cal.fieldLayout[field.id];
      return !!layout;
    });
    // Hanger stores: every name and number draws at ONE letter height per
    // location and field, the rule print runs (GfFixedLetterHeight, a byte copy
    // of personalization/lib/fixed-letter-height.js; Grant 2026-11-02). On the
    // back each half sits in its band of the store's two-half lockup
    // (GfStackedLockup.teamStoreSliceBox with both halves: classic jersey = name
    // on top, 5% gap, number below at 25/75; number-over-name = number on top),
    // typed or not, so a lone name never grows or moves. Elsewhere a lone half
    // is sized from reference strings ("00"/"44"/"88", "SMITH"). Long text
    // condenses to 0.70 before it shrinks. Do not honor blob fieldLayout
    // y/fontSizePct — those leftover-band tokens shrink the stack.
    // Halves the shopper has actually typed, as PRINT reads them: in hanger
    // mode a name or number counts only if something survives print's cleaning
    // (hangerPrintText), so a name of only punctuation next to a number draws
    // the lone number exactly as print sizes it. Other ids pass straight
    // through: the planner lays out only name and number.
    const typedHalves = activeFields
      .filter(f => String(hangerPrintText(f, zs.values[f.id]) || '').trim())
      .map(f => f.id);
    const fillApprovedBox = { x: 0.5, y: 0.5, fontSizePct: 1, align: 'center' };
    // Regular zones: the frame this zone's box is a fraction of, measured on
    // the photo showing now (a zone draws only on its own view's photo; the
    // photo's load re-renders — see bindRegularFrameRerender).
    const regularFrame = wisconsinActive() ? null : regularZoneFrame(cal, measurePreviewPhoto(), svgViewBoxSize());

    if (wisconsinActive() && box) {
      const boxAbs = wisconsinBoxAbs(box);
      const clipId = 'gf-wi-plate-' + String(zs.zoneId).replace(/[^a-zA-Z0-9_-]/g, '-');
      const clipPath = document.createElementNS(SVG_NS, 'clipPath');
      clipPath.setAttribute('id', clipId);
      const rect = document.createElementNS(SVG_NS, 'rect');
      rect.setAttribute('x', String(boxAbs.x));
      rect.setAttribute('y', String(boxAbs.y));
      rect.setAttribute('width', String(boxAbs.w));
      rect.setAttribute('height', String(boxAbs.h));
      clipPath.appendChild(rect);
      ensureDefs().appendChild(clipPath);
      g.setAttribute('clip-path', 'url(#' + clipId + ')');
    } else {
      g.removeAttribute('clip-path');
    }

    for (const field of activeFields) {
      const layout = cal.fieldLayout[field.id];
      const rawValue = zs.values[field.id] || '';
      const isPlaceholder = rawValue.length === 0;
      let text = rawValue;
      if (isPlaceholder) {
        if (!wisconsinActive()) text = zs.placeholderMap[field.id];
        else continue; // hanger mode: typed values only, nothing painted until they type
      }
      if (!text) continue;
      const fixedField = wisconsinActive() && fixedLetterField(field);
      // Hanger names and numbers draw the text print draws (hangerPrintText).
      const display = fixedField ? hangerPrintText(field, text) : (field.uppercase ? text.toUpperCase() : text);
      if (!display) continue;
      const animate = animateField === field.id;
      const built = fixedField
        ? buildStackedFieldElement(zs.zoneId, field, layout, drawBox, display, fill, fontFamilyClass, isPlaceholder, animate, typedHalves, locationId)
        : buildFieldElement(
          zs.zoneId,
          field,
          (wisconsinActive() ? fillApprovedBox : layout),
          drawBox,
          display,
          fill,
          fontFamilyClass,
          isPlaceholder,
          animate,
          regularFrame
        );
      if (!built) continue;
      if (built.defsPath) ensureDefs().appendChild(built.defsPath);
      g.appendChild(built.el);
    }

    applyZoneVisibility(zs);
  }

  function cssEscape(s) {
    return s.replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }

  // Fill-the-zone sizing (product call 2026-07-09): personalization text
  // renders STRAIGHT and fills the zone box calibrated in product-config-admin
  // — the template's legacy shape ('arch-top' etc.) and fontSizePct tokens are
  // intentionally ignored. Start from the box height, cap by the measured
  // glyph run vs the box width (hidden in-document <text> node, so
  // class-resolved webfont metrics apply; advance is linear in font-size, so
  // one measurement is exact), then center the glyphs vertically in the box.
  const FIT_PAD_W = 0.94; // 6% side padding inside the calibrated box
  const FILL_H = 0.95;    // height headroom inside the calibrated box
  let fitMeasureText = null;
  let fitMeasureCtx = null;
  function ensureFitMeasureNodes() {
    if (fitMeasureText) return;
    // Hidden in-document <text> node: resolves the font class to a concrete
    // font-family the same way the render does.
    const holder = document.createElementNS(SVG_NS, 'svg');
    holder.setAttribute('aria-hidden', 'true');
    holder.style.cssText = 'position:absolute;left:-9999px;top:0;width:10px;height:10px;overflow:hidden;visibility:hidden;pointer-events:none;';
    fitMeasureText = document.createElementNS(SVG_NS, 'text');
    holder.appendChild(fitMeasureText);
    document.body.appendChild(holder);
    fitMeasureCtx = document.createElement('canvas').getContext('2d');
  }
  // Ink metrics of `display` at a 100px probe (every metric scales linearly with
  // font-size). Width is the INK width (actualBoundingBoxLeft + Right), not the
  // advance: the print renderer (personalization probeTextInk) fits the trimmed
  // ink, so the preview measures the same thing.
  function measureInk(display, fontFamilyClass) {
    ensureFitMeasureNodes();
    const probe = 100;
    let width = 0, asc = probe * 0.72, desc = 0; // athletic-block estimates
    try {
      fitMeasureText.setAttribute('class', fontFamilyClass);
      const family = getComputedStyle(fitMeasureText).fontFamily || 'sans-serif';
      fitMeasureCtx.font = probe + 'px ' + family;
      const m = fitMeasureCtx.measureText(display);
      width = m.width || 0;
      if (typeof m.actualBoundingBoxLeft === 'number' && typeof m.actualBoundingBoxRight === 'number') {
        const ink = m.actualBoundingBoxLeft + m.actualBoundingBoxRight;
        if (ink > 0) width = ink;
      }
      // Ink extents (not the em box) so uppercase runs truly fill the zone.
      if (typeof m.actualBoundingBoxAscent === 'number') asc = m.actualBoundingBoxAscent;
      if (typeof m.actualBoundingBoxDescent === 'number') desc = m.actualBoundingBoxDescent;
    } catch (e) { /* keep estimates */ }
    if (width <= 0) width = display.length * probe * 0.62; // avg-advance fallback
    return { probe: probe, width: width, asc: asc, inkH: Math.max(1, asc + desc) };
  }
  // Uniform fit (print: renderFillText): a regular (non-hanger) zone field.
  function fitFillFont(display, geom, fontFamilyClass) {
    const availW = geom.boxAbs.w * FIT_PAD_W;
    const availH = geom.boxAbs.h * FILL_H;
    const centerY = geom.boxAbs.y + geom.boxAbs.h / 2;
    if (!display || !display.length) {
      return { fontSize: availH, baselineY: centerY + availH * 0.35 };
    }
    const m = measureInk(display, fontFamilyClass);
    const scale = Math.min(availW / m.width, availH / m.inkH);
    // Center the ink run vertically in the calibrated box.
    return { fontSize: m.probe * scale, baselineY: centerY + (m.asc - m.inkH / 2) * scale, squeezeX: 1 };
  }
  // ONE letter height per location and field (print: personalization
  // renderFixedLetterHeight; both run GfFixedLetterHeight.placeHalf). `box` is
  // the print-shaped box (unit fractions of the hanger), `bands` = { name,
  // number }: both halves' slices of it in the two-half lockup. The letter
  // height comes from the planner's flat reference glyph, so an accent never
  // shrinks the name. Returns null (draw nothing) when the planner did not
  // load — never a guessed size print won't match.
  let warnedNoFixedHeight = false;
  function fixedLetterFont(display, fieldId, box, bands, typedHalves, locationId, fontFamilyClass) {
    const F = window.GfFixedLetterHeight;
    if (!F || typeof F.placeHalf !== 'function') {
      if (!warnedNoFixedHeight) { warnedNoFixedHeight = true; console.warn('[gf-pers] GfFixedLetterHeight missing: name/number preview disabled'); }
      return null;
    }
    const abs = wisconsinBoxAbs(box);
    const onBack = locationId === 'back';
    const inkOf = function (text) {
      const r = measureInk(text, fontFamilyClass);
      return { inkW: r.width, inkH: r.inkH, asc: r.asc };
    };
    const bandOf = function (b) {
      const a = wisconsinBoxAbs(b);
      return { top: a.y - abs.y, height: a.h };
    };
    const m = measureInk(display, fontFamilyClass);
    const plan = F.placeHalf({
      half: fieldId,
      presentHalves: typedHalves || [],
      onBack: onBack,
      box: { w: abs.w, h: abs.h },
      bands: { name: bandOf(bands.name), number: bandOf(bands.number) },
      ink: { inkW: m.width, inkH: m.inkH, asc: m.asc },
      capInk: inkOf(F.capReference(fieldId)),
      refInks: F.needsReferences({ onBack: onBack }) ? F.referenceTexts(fieldId).map(inkOf) : []
    });
    return {
      fontSize: m.probe * plan.scale,
      baselineY: abs.y + plan.inkTop + m.asc * plan.scale,
      squeezeX: plan.squeezeX
    };
  }

  const HANGER_VB = { w: 1000, h: 1200 };
  // Print canvas width:height per location — the zone table
  // (platformConfig/decorationLocations, seeded from scripts/seed-platform-config.js
  // DECORATION_PERSONALIZATION: LS/RS 3.2x3.2 in since 2026-10-06, FB 10x10 in);
  // the print file is rendered on that canvas. Anything unlisted is square.
  const LOCATION_PRINT_ASPECT = { 'left-sleeve': 3.2 / 3.2, 'right-sleeve': 3.2 / 3.2 };
  // The largest box of the location's print aspect, centred in `box` (unit
  // fractions of the 1000x1200 hanger).
  function printAspectBox(box, locationId) {
    if (!box) return box;
    const aspect = LOCATION_PRINT_ASPECT[locationId] || 1;
    const wPx = box.w * HANGER_VB.w;
    const hPx = box.h * HANGER_VB.h;
    let w = wPx;
    let h = hPx;
    if (wPx / hPx > aspect) w = hPx * aspect; else h = wPx / aspect;
    return {
      x: box.x + (wPx - w) / 2 / HANGER_VB.w,
      y: box.y + (hPx - h) / 2 / HANGER_VB.h,
      w: w / HANGER_VB.w,
      h: h / HANGER_VB.h
    };
  }
  function wisconsinBoxAbs(box) {
    return {
      x: box.x * HANGER_VB.w,
      y: box.y * HANGER_VB.h,
      w: box.w * HANGER_VB.w,
      h: box.h * HANGER_VB.h
    };
  }
  function resolveWisconsinGeometry(box, layout) {
    const boxAbs = wisconsinBoxAbs(box);
    const lx = layout && layout.x != null ? layout.x : 0.5;
    const ly = layout && layout.y != null ? layout.y : 0.5;
    return {
      cx: boxAbs.x + lx * boxAbs.w,
      cy: boxAbs.y + ly * boxAbs.h,
      fontSize: boxAbs.h * ((layout && layout.fontSizePct) || 1),
      boxAbs: boxAbs
    };
  }
  // -------------------------------------------------------------------
  // Regular (zones[]) boxes. A SEEDED calibration box is a fraction of the
  // calibrator's frame: productconfig-dashboard lays a 1000×1000 viewBox
  // "meet" over the photo, i.e. the largest square centred in it. The preview
  // here is a 1000×1200 viewBox over a contained photo in a wrapper whose
  // aspect varies with the layout, so the frame is measured, not assumed.
  // (Drawing box × 1000 from the top-left put names 100 units — 8% — too
  // high, and at the wrong scale on a phone; 2026-09-24.) An
  // 'approved-print-box' calibration (v4 placementAnchorFor) is a fraction of
  // the photo itself — the 1000×1200 hanger it was approved on.
  // -------------------------------------------------------------------
  // Where the photo and the calibrator's square sit, in viewBox units, or null
  // when unmeasurable (dialog closed, photo not loaded). Pure: m = { svgRect,
  // imgRect (getBoundingClientRect), viewBox {width,height}, natural
  // {width,height} (the photo's pixels), objectFit (the <img>'s) }.
  function previewPhotoFrames(m) {
    const vb = m && m.viewBox;
    const sr = m && m.svgRect;
    const ir = m && m.imgRect;
    const n = m && m.natural;
    const positive = (r, a, b) => !!r && r[a] > 0 && r[b] > 0;
    if (!positive(vb, 'width', 'height') || !positive(sr, 'width', 'height')
      || !positive(ir, 'width', 'height') || !positive(n, 'width', 'height')) return null;
    // svg user space: preserveAspectRatio xMidYMid meet
    const k = Math.min(sr.width / vb.width, sr.height / vb.height);
    const ox = sr.left + (sr.width - vb.width * k) / 2;
    const oy = sr.top + (sr.height - vb.height * k) / 2;
    // the photo inside its <img> box, per object-fit (centred)
    let sx;
    let sy;
    if (m.objectFit === 'fill') {
      sx = ir.width / n.width;
      sy = ir.height / n.height;
    } else {
      sx = sy = (m.objectFit === 'cover' ? Math.max : Math.min)(ir.width / n.width, ir.height / n.height);
    }
    const px = ir.left + (ir.width - n.width * sx) / 2;
    const py = ir.top + (ir.height - n.height * sy) / 2;
    const side = Math.min(n.width, n.height);
    const toViewBox = (x, y, w, h) => ({ x: (x - ox) / k, y: (y - oy) / k, w: w / k, h: h / k });
    return {
      photo: toViewBox(px, py, n.width * sx, n.height * sy),
      calibrator: toViewBox(px + ((n.width - side) / 2) * sx, py + ((n.height - side) / 2) * sy, side * sx, side * sy),
    };
  }
  // The frame a zone's box is a fraction of. Unmeasured → the viewBox's centred
  // square (a 1000×1000 overlay keeps the old × 1000 mapping), or the whole
  // viewBox for an approved box.
  function regularZoneFrame(calibration, frames, viewBox) {
    const approved = !!calibration && calibration.source === 'approved-print-box';
    if (frames) return approved ? frames.photo : frames.calibrator;
    if (approved) return { x: 0, y: 0, w: viewBox.width, h: viewBox.height };
    const side = Math.min(viewBox.width, viewBox.height);
    return { x: (viewBox.width - side) / 2, y: (viewBox.height - side) / 2, w: side, h: side };
  }
  function resolveFrameGeometry(box, layout, frame) {
    const boxAbs = {
      x: frame.x + box.x * frame.w,
      y: frame.y + box.y * frame.h,
      w: box.w * frame.w,
      h: box.h * frame.h
    };
    return {
      cx: boxAbs.x + layout.x * boxAbs.w,
      cy: boxAbs.y + layout.y * boxAbs.h,
      fontSize: boxAbs.h * (layout.fontSizePct || 0.5),
      boxAbs: boxAbs
    };
  }
  // A regular zone's frame is measured on the live layout, so re-render when
  // the photo (re)loads — a thumb click swaps it — and when the preview box
  // resizes (the modal opening, rotation). Hanger stores map on the fixed
  // 1000×1200 hanger and need neither.
  function bindRegularFrameRerender() {
    if (wisconsinActive()) return;
    let queued = false;
    let mounted = true;
    const rerender = () => {
      if (queued || !mounted) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; if (mounted) renderAllZonesSVG(); });
    };
    if (mainImg) mainImg.addEventListener('load', rerender);
    const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(rerender) : null;
    if (observer) observer.observe(svg);
    // A theme-editor re-mount (shopify:section:load) runs cleanup(): let go
    // of this mount's photo and resize hooks too.
    const priorCleanup = cleanup;
    cleanup = function () {
      priorCleanup();
      mounted = false;
      if (observer) observer.disconnect();
      if (mainImg) mainImg.removeEventListener('load', rerender);
    };
  }
  function svgViewBoxSize() {
    const vb = svg.viewBox && svg.viewBox.baseVal;
    return vb && vb.width > 0 && vb.height > 0 ? { width: vb.width, height: vb.height } : { width: 1000, height: 1000 };
  }
  function measurePreviewPhoto() {
    if (!mainImg || !mainImg.naturalWidth) return null;
    let objectFit = 'fill';
    try { objectFit = window.getComputedStyle(mainImg).objectFit || 'fill'; } catch (e) { /* keep default */ }
    return previewPhotoFrames({
      svgRect: svg.getBoundingClientRect(),
      imgRect: mainImg.getBoundingClientRect(),
      viewBox: svgViewBoxSize(),
      natural: { width: mainImg.naturalWidth, height: mainImg.naturalHeight },
      objectFit: objectFit
    });
  }

  function syncWisconsinSvgViewBox() {
    if (!svg || !wisconsinActive()) return;
    svg.setAttribute('viewBox', '0 0 1000 1200');
    svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
  }
  if (wisconsinActive()) syncWisconsinSvgViewBox();

  let warnedNoLockup = false;
  function stackedSliceBox(box, fieldId, typedHalves) {
    const L = window.GfStackedLockup;
    if (!L || typeof L.teamStoreSliceBox !== 'function') {
      // gf-stacked-lockup.js did not load. Draw nothing (never a guessed layout
      // print won't match) and never throw: a throw here skips updatePricing()
      // and the cart gets the unpersonalized variant.
      if (!warnedNoLockup) { warnedNoLockup = true; console.warn('[gf-pers] GfStackedLockup missing: name+number preview disabled'); }
      return null;
    }
    return L.teamStoreSliceBox(box, fieldId, typedHalves, STORE_LOCKUP);
  }

  // Hanger mode draws only names and numbers at the fixed letter height.
  function fixedLetterField(field) {
    return !!field && (field.id === 'name' || field.id === 'number');
  }
  // In hanger mode, what print keeps of a typed name or number
  // (GfFixedLetterHeight.printText = orderwebhook cleanName / cleanNumber):
  // upper-cased letters, digits, Latin-1 capitals and single spaces for a
  // name, digits for a number. Hanger fields are all name / number, so with
  // no planner loaded the raw value passes (nothing draws then anyway); any
  // other field and regular mode pass the value through unchanged.
  function hangerPrintText(field, value) {
    const v = String(value == null ? '' : value);
    if (!wisconsinActive() || !fixedLetterField(field)) return v;
    const F = window.GfFixedLetterHeight;
    if (!F || typeof F.printText !== 'function') return v;
    return F.printText(field.id, v, field.maxChars > 0 ? field.maxChars : undefined);
  }

  function buildStackedFieldElement(zoneId, field, layout, box, display, fill, fontFamilyClass, isPlaceholder, animate, typedHalves, locationId) {
    const Svg = window.GfSvg;
    // Both halves' bands in the store's two-half lockup, whether or not the
    // other half is typed (the planner decides whether it draws there).
    // layout.y / layout.fontSizePct are stale leftover-band tokens and must
    // not drive size or position.
    const bands = {
      name: stackedSliceBox(box, 'name', ['name', 'number']),
      number: stackedSliceBox(box, 'number', ['name', 'number'])
    };
    if (!bands.name || !bands.number || !field || !bands[field.id]) return null;
    const align = (layout && layout.align) || 'center';
    const geom = wisconsinActive()
      ? resolveWisconsinGeometry(box, { x: 0.5, y: 0.5, fontSizePct: 1, align: align })
      : Svg.resolveFieldGeometry(box, { x: 0.5, y: 0.5, fontSizePct: 1, align: align }, 1000);
    const fitted = fixedLetterFont(display, field.id, box, bands, typedHalves, locationId, fontFamilyClass);
    if (!fitted) return null;
    const textEl = document.createElementNS(SVG_NS, 'text');
    textEl.setAttribute('font-size', fitted.fontSize);
    textEl.setAttribute('text-anchor', align === 'center' ? 'middle' : (align === 'right' ? 'end' : 'start'));
    textEl.setAttribute('fill', fill);
    textEl.setAttribute('class', fontFamilyClass);
    if (isPlaceholder && !wisconsinActive()) {
      textEl.setAttribute('opacity', '0.42');
      textEl.setAttribute('font-style', 'italic');
    }
    if (animate && !isPlaceholder) {
      textEl.classList.add('is-fresh');
      setTimeout(() => textEl.classList.remove('is-fresh'), 350);
    }
    if (fitted.squeezeX && fitted.squeezeX < 1) {
      // Same squeeze as print: a horizontal scale around the text's centre.
      textEl.setAttribute('x', '0');
      textEl.setAttribute('y', '0');
      textEl.setAttribute('transform', 'translate(' + geom.cx + ' ' + fitted.baselineY + ') scale(' + fitted.squeezeX + ' 1)');
    } else {
      textEl.setAttribute('x', geom.cx);
      textEl.setAttribute('y', fitted.baselineY);
    }
    textEl.textContent = display;
    return { el: textEl, defsPath: null };
  }

  function buildFieldElement(zoneId, field, layout, box, display, fill, fontFamilyClass, isPlaceholder, animate, frame) {
    const geom = wisconsinActive()
      ? resolveWisconsinGeometry(box, layout)
      : resolveFrameGeometry(box, layout, frame);

    // Straight fill only — no arcs/slants (product call 2026-07-09). The
    // curved-shape path builders remain in GfSvg for the admin tooling.
    const fitted = fitFillFont(display, geom, fontFamilyClass);

    const textEl = document.createElementNS(SVG_NS, 'text');
    textEl.setAttribute('font-size', fitted.fontSize);
    textEl.setAttribute('text-anchor', layout.align === 'center' ? 'middle' : (layout.align === 'right' ? 'end' : 'start'));
    textEl.setAttribute('fill', fill);
    textEl.setAttribute('class', fontFamilyClass);
    // No stroke/outline on personalization text (product call 2026-07-09) —
    // the ink color chooser (white/black/primary/secondary) is the contrast tool.
    if (isPlaceholder && !wisconsinActive()) {
      textEl.setAttribute('opacity', '0.42');
      textEl.setAttribute('font-style', 'italic');
    }
    if (animate && !isPlaceholder) {
      textEl.classList.add('is-fresh');
      setTimeout(() => textEl.classList.remove('is-fresh'), 350);
    }

    textEl.setAttribute('x', geom.cx);
    textEl.setAttribute('y', fitted.baselineY);
    textEl.textContent = display;
    return { el: textEl, defsPath: null };
  }

  // Every filled location OTHER than the one in the form gets its own preview
  // group (#1123): a back name stays drawn while the shopper types a sleeve
  // number, and each group shows only on its own view's photo
  // (applyZoneVisibility). They borrow the form zone's template and font and
  // carry their own calibration, type, values and ink.
  let hangerGhosts = [];
  function renderHangerGhosts() {
    hangerGhosts.forEach(function (ghost) {
      const old = svg.querySelector('g[data-zone-id="' + cssEscape(ghost.zoneId) + '"]');
      if (old) old.parentNode.removeChild(old);
    });
    hangerGhosts = [];
    const zs0 = zoneStates[0];
    if (!wisconsinActive() || !zs0) return;
    hangerGhosts = wisconsinFilledLocations().filter(f => f.id !== wiLocationId).map(function (f) {
      const loc = (wiOffer.locations || []).find(l => l.id === f.id);
      const zone = {
        id: zs0.zone.id, templateId: zs0.zone.templateId, template: zs0.zone.template,
        label: loc.label, calibration: hangerCalibrationFor(loc)
      };
      return {
        zoneId: 'loc-' + f.id, zone: zone, enabled: true, values: f.values,
        font: zs0.font, inkColor: f.ink || zs0.inkColor, placeholderMap: zs0.placeholderMap,
        targetImageIndex: viewIndexForZone(zone), hangerType: f.type, hangerLocationId: f.id
      };
    });
    hangerGhosts.forEach(ghost => renderZoneSVG(ghost));
  }

  function renderAllZonesSVG() {
    for (const zs of zoneStates) renderZoneSVG(zs);
    renderHangerGhosts();
    updateSvgEmptyState();
  }

  // The review draws every filled spot at once, so it copies the groups the
  // engine already drew instead of walking the one <img> through each photo.
  function filledPreviewZones() {
    return zoneStates.concat(hangerGhosts).filter(zs => zs.enabled && zoneHasEnteredValues(zs));
  }
  function cloneViewSvg(index) {
    const out = document.createElementNS(SVG_NS, 'svg');
    // Same class for the overlay CSS; never id="pd-pers-svg" (the engine's own).
    out.setAttribute('class', 'pd-pers-svg');
    out.setAttribute('viewBox', svg.getAttribute('viewBox') || '0 0 1000 1200');
    out.setAttribute('preserveAspectRatio', 'xMidYMid meet');
    out.setAttribute('aria-hidden', 'true');
    filledPreviewZones().filter(zs => zs.targetImageIndex === index).forEach(zs => {
      const g = svg.querySelector('g[data-zone-id="' + cssEscape(zs.zoneId) + '"]');
      if (g) out.appendChild(prepareReviewClone(g.cloneNode(true), index));
    });
    return out;
  }
  // null = no review step on this product (the controller adds directly).
  function reviewModel() {
    const zs0 = zoneStates[0];
    if (!wisconsinActive() || !zs0) return null;
    // Redraws without a just-typed field's short-lived is-fresh class, which a
    // clone would keep with nothing left to remove it.
    renderAllZonesSVG();
    const spots = reviewSpotRows(wisconsinFilledLocations(), wisconsinLocationLabel, locationAddonCents(), hangerFieldUppercase)
      .map(row => Object.assign(row, {
        inkHex: resolveColor(row.ink || zs0.inkColor),
        inkName: prettyInkName(row.ink || zs0.inkColor)
      }));
    const zones = filledPreviewZones();
    const spotIdFor = zs => zs.hangerLocationId || wiLocationId;
    const thumbViews = thumbs.map((t, i) => ({
      view: ((t.dataset && t.dataset.view) || '').toLowerCase(),
      label: String(t.textContent || '').trim(),
      src: t.dataset && t.dataset.imgSrc,
      index: i
    }));
    const views = reviewViewList(thumbViews, zones.map(zs => zs.targetImageIndex)).map(v => {
      const spotIds = zones.filter(zs => zs.targetImageIndex === v.index).map(spotIdFor);
      const texts = spots.filter(row => spotIds.indexOf(row.id) !== -1).map(row => row.text);
      return Object.assign(v, {
        spotIds: spotIds,
        alt: v.label + (texts.length ? ' with ' + texts.join(', ') : ''),
        svgEl: cloneViewSvg(v.index)
      });
    });
    return { spots: spots, views: views };
  }

  function applyZoneVisibility(zs) {
    const g = svg.querySelector('g[data-zone-id="' + cssEscape(zs.zoneId) + '"]');
    if (!g) return;
    // A preview group for a location not being edited whose view has no photo
    // (targetImageIndex -1) must not draw on whichever photo is showing.
    const noPhoto = !!zs.hangerLocationId && zs.targetImageIndex < 0;
    const visible = zs.enabled && !noPhoto && (activeImageIndex === zs.targetImageIndex);
    g.style.display = visible ? '' : 'none';
  }

  function applyAllZoneVisibility() {
    for (const zs of zoneStates) applyZoneVisibility(zs);
    for (const ghost of hangerGhosts) applyZoneVisibility(ghost);
    updateSvgEmptyState();
    updateZoneViewHints();
  }

  function updateSvgEmptyState() {
    if (wisconsinActive()) {
      // The YOUR PERSONALIZATION prompt paints at full ink — never fade the plate.
      svg.dataset.empty = 'false';
      return;
    }
    const anyVisibleWithValue = zoneStates.some(zs =>
      zs.enabled && activeImageIndex === zs.targetImageIndex && zoneHasEnteredValues(zs)
    );
    svg.dataset.empty = anyVisibleWithValue ? 'false' : 'true';
  }

  function wisconsinHintCopy() {
    const loc = currentWisconsinLocation();
    const label = (loc && loc.label)
      || prettyViewLabel(loc && loc.view)
      || prettyViewLabel(viewForWisconsinLocation(wiLocationId));
    return 'Personalization prints on the <strong>' + escapeHtml(label) + '</strong>';
  }
  function activePreviewPlacement() {
    const activeThumb = thumbs[activeImageIndex];
    const activeView = activeThumb && activeThumb.dataset && String(activeThumb.dataset.view || '').toLowerCase();
    if (activeView) return activeView;
    const frontIndex = thumbs.findIndex(function (thumb) {
      return thumb && thumb.dataset && String(thumb.dataset.view || '').toLowerCase() === 'front';
    });
    return activeImageIndex === (frontIndex >= 0 ? frontIndex : 0) ? 'front' : '';
  }
  function activePreviewIsFront() {
    return activePreviewPlacement() === 'front';
  }
  function placementKey(value) {
    const key = String(value || '').toLowerCase().replace(/[\s_]+/g, '-');
    if (key === 'left-sleeve' || key === 'left-side') return 'left-side';
    if (key === 'right-sleeve' || key === 'right-side') return 'right-side';
    return key;
  }
  function updateZoneViewHints() {
    const activePlacement = activePreviewPlacement();
    if (zonesContainer) zonesContainer.dataset.previewPlacement = activePlacement;
    for (const zs of zoneStates) {
      const hint = zonesContainer.querySelector('[data-zone-view-hint-for="' + cssEscape(zs.zoneId) + '"]');
      if (!hint) continue;
      if (wisconsinActive()) {
        const span = hint.querySelector('span');
        if (span) span.innerHTML = wisconsinHintCopy();
      }
      // Show hint only when the active product view differs from the print
      // placement. The front view is intentionally quiet, so a back zone
      // never leaves stale “prints on the Back” copy visible after a tap.
      const targetPlacement = placementKey(zs.zone.calibration && zs.zone.calibration.view);
      const samePlacement = placementKey(activePlacement) && targetPlacement && placementKey(activePlacement) === targetPlacement;
      hint.classList.toggle('is-visible', !samePlacement && !activePreviewIsFront() && zs.enabled && activeImageIndex !== zs.targetImageIndex);
      hint.setAttribute('aria-hidden', hint.classList.contains('is-visible') ? 'false' : 'true');
    }
    // Hide the global liquid-rendered view hint — Phase 2 uses per-zone hints.
    if (globalViewHint) globalViewHint.classList.remove('is-visible');
  }

  // -------------------------------------------------------------------
  // Pricing — total addon = sum of enabled zones, written into header badge
  // and the Add to Bag CTA. Single-zone behavior preserved by treating
  // zone.enabled = true as the default.
  // -------------------------------------------------------------------
  function updatePricing() {
    let totalAddonCents = 0;
    let anyEnabledWithValue = false;
    for (const zs of zoneStates) {
      if (!zs.enabled) continue;
      if (zoneHasEnteredValues(zs)) anyEnabledWithValue = true;
      // We count addon regardless of values entered (consistent with
      // toggle semantics: enabling a zone commits to its addon).
      totalAddonCents += zoneAddonCents(zs);
    }

    if (priceBadge) {
      priceBadge.textContent = '+$' + (totalAddonCents / 100).toFixed(2).replace(/\.00$/, '');
      priceBadge.classList.toggle('is-active', totalAddonCents > 0);
    }
    if (resetBtn) resetBtn.classList.toggle('is-visible', anyEnabledWithValue || totalAddonCents > 0);

    // Wisconsin / modal Add-to-Bag: garment + customization delta.
    // Ghost Fit house: $0 (do not add $10). Other brands: $10 per location
    // that has a real typed name/number. The empty plate's YOUR PERSONALIZATION
    // prompt is never written into values, so it does not count.
    const modalTotal = document.getElementById('pd-pz-total');
    if (modalTotal && (wisconsinActive() || isGhostFitHouseBrand())) {
      // gf-storefront.js writes the selected size's BASE price in cents on the
      // zones container (resolve()); fall back to the first-paint text.
      const baseCentsAttr = zonesContainer && zonesContainer.dataset.basePriceCents;
      if (baseCentsAttr && /^\d+$/.test(baseCentsAttr)) {
        modalTotal.dataset.basePrice = formatMoneyLike(modalTotal.dataset.basePrice || modalTotal.textContent, parseInt(baseCentsAttr, 10));
      } else if (!modalTotal.dataset.basePrice) {
        modalTotal.dataset.basePrice = modalTotal.textContent;
      }
      const filled = wisconsinFilledLocationCount();
      const addon = isGhostFitHouseBrand() ? 0 : locationAddonCents() * filled;
      const base = parsePriceCents(modalTotal.dataset.basePrice);
      if (base != null && addon > 0) {
        modalTotal.textContent = modalTotal.dataset.basePrice.replace(/[\d.,]+/, ((base + addon) / 100).toFixed(2));
      } else {
        modalTotal.textContent = modalTotal.dataset.basePrice;
      }
    }

    // Hand-off to gf-storefront.js: the filled-location count decides which
    // "(Personalized ×k)" variant the cart gets. Announce changes that do not
    // come from an <input> event (location switch, type switch).
    // Location chips: ✓ follows typing, so it refreshes on every pass.
    if (wisconsinActive()) syncLocationChips();
    if (zonesContainer) {
      const filledNow = String(wisconsinFilledLocationCount());
      if (zonesContainer.dataset.filledLocations !== filledNow) {
        zonesContainer.dataset.filledLocations = filledNow;
        zonesContainer.dispatchEvent(new CustomEvent('gf:pers-change', { bubbles: true }));
      }
      // Human summary for the buy box's choice card ("NOBLE 37 · Back · School
      // color"). Published on every pricing pass; announced only when it changes.
      const summaryNow = personalizationStatus().summary;
      if (zonesContainer.dataset.persSummary !== summaryNow) {
        zonesContainer.dataset.persSummary = summaryNow;
        zonesContainer.dispatchEvent(new CustomEvent('gf:pers-summary', { bubbles: true }));
      }
    }

    zonesContainer.dispatchEvent(new CustomEvent('gf:pers-state', { bubbles: true }));

    // Opt-out: when the CTA price span carries data-gf-pers-noautoprice, the
    // host page owns the Add-to-Bag price (e.g. the v4 PDP, where personalization
    // is OPTIONAL and sold as one "(Personalized)" variant at base+combinedAddon —
    // gf-storefront.js swaps the variant + price when a field is filled). The
    // engine's per-zone incremental sum would disagree with that single-variant
    // price, so leave the CTA alone there. The header badge below still updates.
    if (ctaPrice && !ctaPrice.dataset.gfPersNoautoprice && basePriceCents != null) {
      const total = basePriceCents + totalAddonCents;
      if (!ctaPrice.dataset.basePrice) ctaPrice.dataset.basePrice = ctaPrice.textContent;
      ctaPrice.textContent = ctaPrice.dataset.basePrice.replace(/[\d.,]+/, (total / 100).toFixed(2));
    }
  }

  // -------------------------------------------------------------------
  // Image gallery wiring — track which view is currently shown and let
  // zones know whether their SVG <g> should be visible.
  // -------------------------------------------------------------------
  function setMainImage(src) {
    if (!mainImg || !src) return;
    // The main <img> ships with srcset (multiple resolutions of the
    // featured image). Browser uses srcset over src — clear it first.
    mainImg.removeAttribute('srcset');
    mainImg.src = src;
  }

  function setActiveImage(index, opts) {
    if (index < 0 || index >= thumbs.length) {
      // No thumb for this index — just track state for SVG visibility.
      activeImageIndex = index;
      applyAllZoneVisibility();
      return;
    }
    setMainImage(thumbs[index].dataset.imgSrc);
    thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
    activeImageIndex = index;
    applyAllZoneVisibility();
  }

  thumbs.forEach((thumb, i) => {
    thumb.addEventListener('click', () => {
      setActiveImage(i);
      if (!wisconsinActive()) return;
      const view = ((thumb.dataset && thumb.dataset.view) || '').toLowerCase();
      switchHangerLocation(wisconsinOpenLocationForView(view));
    });
  });

  // -------------------------------------------------------------------
  // Event handlers — input changes, swatch clicks, zone toggles, focus
  // -------------------------------------------------------------------
  function bindHandlers() {
    // Input changes (text + font select live here too)
    zonesContainer.addEventListener('input', e => {
      const target = e.target;
      // Field input
      const fieldKey = target.dataset.zoneField;
      if (fieldKey) {
        const [zoneId, fieldId] = fieldKey.split(':');
        const zs = zoneStates.find(z => z.zoneId === zoneId);
        if (!zs) return;
        reviewedVersion = '';
        // Auto-enable when typing into a zone's input (multi-zone case)
        if (!zs.enabled) {
          setZoneEnabled(zs, true);
        }
        const before = zs.values[fieldId] || '';
        const after = target.value;
        zs.values[fieldId] = after;
        // Hanger: the type is what has been typed (no Type picker).
        if (wisconsinActive()) wiType = deriveHangerType(zs.values) || hangerDefaultType();
        const counter = zonesContainer.querySelector('[data-counter-for="' + cssEscape(zoneId + ':' + fieldId) + '"]');
        if (counter) {
          const f = zs.zone.template.fields.find(x => x.id === fieldId);
          const max = f ? f.maxChars : 0;
          counter.textContent = after.length + ' / ' + max;
          counter.classList.toggle('is-full', max > 0 && after.length === max);
        }
        const animate = before.length === 0 && after.length > 0 ? fieldId : null;
        renderZoneSVG(zs, { animateField: animate });
        updateSvgEmptyState();
        updatePricing();
        return;
      }
      // Font select
      const fontZoneId = target.dataset.zoneFont;
      if (fontZoneId) {
        const zs = zoneStates.find(z => z.zoneId === fontZoneId);
        if (!zs) return;
        reviewedVersion = '';
        zs.font = target.value;
        renderZoneSVG(zs);
        updatePricing();
        return;
      }
    });

    // Click delegation — location chips, swatches, toggles
    zonesContainer.addEventListener('click', e => {
      const chip = e.target.closest('[data-wi-location-chip]');
      if (chip) {
        if (chip.dataset.blocked) viewBlockedLocation(chip);
        else switchHangerLocation(chip.dataset.wiLocationChip);
        return;
      }
      // Ink swatch
      const swatchBtn = e.target.closest('.pd-pers-swatch');
      if (swatchBtn && swatchBtn.disabled) return;
      if (swatchBtn) {
        const row = swatchBtn.closest('[data-zone-swatches-for]');
        if (!row) return;
        const zoneId = row.dataset.zoneSwatchesFor;
        const zs = zoneStates.find(z => z.zoneId === zoneId);
        if (!zs) return;
        const c = swatchBtn.dataset.inkColor;
        if (!c) return;
        reviewedVersion = '';
        zs.inkColor = c;
        syncInkSwatches(zs);
        if (wisconsinActive()) {
          // This ink belongs to the location being edited; it also seeds the
          // next location the shopper opens.
          lastPickedInk = c;
          rememberWisconsinStamp();
        }
        renderZoneSVG(zs);
        updatePricing();
        return;
      }
    });

    // Zone toggle (checkbox) — change event
    zonesContainer.addEventListener('change', e => {
      const toggleZoneId = e.target.dataset.zoneToggle;
      if (!toggleZoneId) return;
      const zs = zoneStates.find(z => z.zoneId === toggleZoneId);
      if (!zs) return;
      setZoneEnabled(zs, e.target.checked);
    });

    // Focus auto-switch — when customer focuses anything inside a zone's
    // body, snap the gallery to that zone's view.
    // gf-storefront.js announces a new selected-size base price here; the modal
    // total is base + add-on, so it has to be recomputed. updatePricing()'s own
    // gf:pers-change dispatch is change-guarded, so this cannot loop.
    zonesContainer.addEventListener('gf:base-price', updatePricing);

    zonesContainer.addEventListener('focusin', e => {
      // Chips handle their own view (a blocked chip shows ITS photo).
      if (e.target.closest('[data-wi-location-chip]')) return;
      // Back to editing after viewing a blocked spot.
      if (wisconsinActive()) syncLocationChips();
      const card = e.target.closest('.pd-pers-zone');
      if (!card) return;
      const zoneId = card.dataset.zoneId;
      const zs = zoneStates.find(z => z.zoneId === zoneId);
      if (!zs) return;
      if (activeImageIndex !== zs.targetImageIndex) {
        setActiveImage(zs.targetImageIndex);
      }
    });

    // Reset restores the engine's initial state, including hidden locations.
    if (resetBtn) resetBtn.addEventListener('click', resetAllPersonalization);
    document.addEventListener('gf:pers-reset', resetAllPersonalization);

    // Cart submit
    let form;
    refreshCartBinding = function () {
      const next = document.querySelector('form[action*="/cart/add"]');
      if (next === form) return;
      if (form) form.removeEventListener('submit', writeCartProperties);
      form = next;
      if (form) form.addEventListener('submit', writeCartProperties);
    };
    refreshCartBinding();
    cleanup = function () {
      document.removeEventListener('gf:pers-reset', resetAllPersonalization);
      if (form) form.removeEventListener('submit', writeCartProperties);
    };
  }

  // In-memory editor boundary. Snapshots contain shopper choices only; geometry,
  // templates and production property serialization stay owned by this engine.
  let initialSnapshot;
  // The review wording the shopper ticked for exactly these choices. Any change
  // to them clears it, so a cart line never claims a review of other text.
  let reviewedVersion = '';
  function markReviewed(version) { reviewedVersion = String(version || ''); }
  function snapshotPersonalization() {
    rememberWisconsinStamp();
    return {
      version: 1,
      zones: zoneStates.map(zs => ({
        zoneId: zs.zoneId, enabled: zs.enabled, values: Object.assign({}, zs.values),
        font: zs.font, inkColor: zs.inkColor, targetImageIndex: zs.targetImageIndex
      })),
      wiType: wiType,
      wiLocationId: wiLocationId,
      wiStamps: JSON.parse(JSON.stringify(wiStamps)),
      lastPickedInk: lastPickedInk,
      reviewedVersion: reviewedVersion,
      activeImageIndex: activeImageIndex
    };
  }

  function restorePersonalization(snapshot) {
    if (!snapshot || snapshot.version !== 1 || !Array.isArray(snapshot.zones)
      || snapshot.zones.length !== zoneStates.length
      || snapshot.zones.some((zs, i) => zs.zoneId !== zoneStates[i].zoneId)) return false;
    snapshot.zones.forEach((saved, i) => {
      Object.assign(zoneStates[i], {
        enabled: saved.enabled, values: Object.assign({}, saved.values),
        font: saved.font, inkColor: saved.inkColor, targetImageIndex: saved.targetImageIndex
      });
    });
    Object.keys(wiStamps).forEach(id => { delete wiStamps[id]; });
    Object.assign(wiStamps, JSON.parse(JSON.stringify(snapshot.wiStamps || {})));
    wiType = snapshot.wiType;
    wiLocationId = snapshot.wiLocationId;
    lastPickedInk = snapshot.lastPickedInk || '';
    reviewedVersion = snapshot.reviewedVersion || '';
    buildAllCards();
    if (wisconsinActive()) {
      applyWisconsinLocationState();
    }
    renderAllZonesSVG();
    setActiveImage(snapshot.activeImageIndex);
    updateSvgEmptyState();
    updatePricing();
    return true;
  }

  function resetAllPersonalization() {
    if (initialSnapshot) restorePersonalization(initialSnapshot);
  }

  function personalizationStatus() {
    const filled = zoneStates.filter(zs => zs.enabled && zoneHasEnteredValues(zs));
    const filledLocations = wisconsinFilledLocationCount();
    const addonCents = wisconsinActive()
      ? locationAddonCents() * filledLocations
      : filled.reduce((total, zs) => total + zoneAddonCents(zs), 0);
    const summary = wisconsinActive() ? wisconsinPersonalizationSummary() : filled.map(zs => {
      const text = zs.zone.template.fields.map(field => {
        const value = String(zs.values[field.id] || '').trim();
        return field.uppercase ? value.toUpperCase() : value;
      }).filter(Boolean).join(' ');
      return text + ' on ' + zoneLabel(zs) + ' · ' + prettyInkName(zs.inkColor);
    }).join(', ');
    const rates = zoneStates.map(zs => zoneAddonCents(zs));
    return {
      filledLocations: filledLocations, addonCents: addonCents, summary: summary,
      perLocationCents: wisconsinActive() ? locationAddonCents() : Math.min.apply(null, rates),
      varyingRates: !wisconsinActive() && new Set(rates).size > 1,
      reviewable: wisconsinActive()
    };
  }

  function validatePersonalization() {
    const locations = wisconsinActive()
      ? wisconsinFilledLocations().map(loc => ({
        zoneId: zoneStates[0].zoneId, locationId: loc.id,
        values: loc.values, fields: zoneStates[0].zone.template.fields.filter(field => wisconsinFieldsForType(loc.type).includes(field.id))
      }))
      : zoneStates.filter(zs => zs.enabled && zoneHasEnteredValues(zs)).map(zs => ({
        zoneId: zs.zoneId, locationId: zs.zoneId, values: zs.values, fields: zs.zone.template.fields
      }));
    if (!locations.length) {
      return { valid: false, message: wisconsinActive() && hangerAwaitingPick
        ? availableSpotsSentence(hangerOpenLabels(), MODE_COPY.what)
        : MODE_COPY.missing };
    }
    for (const location of locations) {
      for (const field of location.fields) {
        const value = String(location.values[field.id] || '');
        let message = '';
        if (field.required && !value.trim()) message = 'Enter ' + (field.label || field.id) + '.';
        else if (field.type === 'numeric' && value && !/^[0-9]+$/.test(value)) message = (field.label || 'Number') + ' must contain digits only.';
        else if (field.maxChars > 0 && value.length > field.maxChars) message = (field.label || field.id) + ' must be ' + field.maxChars + ' characters or fewer.';
        if (message) return { valid: false, message: message, zoneId: location.zoneId, locationId: location.locationId, fieldId: field.id };
      }
    }
    return { valid: true };
  }

  function setZoneEnabled(zs, enabled) {
    reviewedVersion = '';
    zs.enabled = enabled;
    if (!enabled) {
      for (const field of zs.zone.template.fields) {
        zs.values[field.id] = '';
        const input = zonesContainer.querySelector('input[data-zone-field="' + cssEscape(zs.zoneId + ':' + field.id) + '"]');
        if (input) input.value = '';
      }
    }
    const card = zonesContainer.querySelector('.pd-pers-zone[data-zone-id="' + cssEscape(zs.zoneId) + '"]');
    if (card) card.classList.toggle('is-enabled', enabled);
    const body = card && card.querySelector('.pd-pers-zone-body');
    if (body) body.hidden = !enabled;
    const toggle = zonesContainer.querySelector('input[data-zone-toggle="' + cssEscape(zs.zoneId) + '"]');
    if (toggle && toggle.checked !== enabled) toggle.checked = enabled;
    applyZoneVisibility(zs);
    updatePricing();
    // When enabling, snap to this zone's view so the customer sees their preview.
    if (enabled && activeImageIndex !== zs.targetImageIndex) {
      setActiveImage(zs.targetImageIndex);
    }
  }

  // -------------------------------------------------------------------
  // Cart property writer — zone-scoped keys + legacy back-compat from
  // the first enabled zone so the order-webhook (Phase 4) keeps parsing
  // until it's updated.
  // -------------------------------------------------------------------
  function writeCartProperties(/* submitEvent */) {
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    clearCartProperties(form);
    let totalAddonCents = 0;
    let firstEnabled = null;
    const zs0 = zoneStates[0];

    if (wisconsinActive() && zs0) {
      // Per-location: ONE group per FILLED location, each with its own type,
      // fields and INK (orderwebhook prints and ink-checks every zone on its
      // own). The store font is one id for every location.
      const pairs = hangerCartProperties(wisconsinFilledLocations(), {
        templateId: zs0.zone.templateId,
        configId: window.GHOSTFIT_PRODUCT_CONFIG_ID || '',
        font: zs0.font,
        perLocationCents: locationAddonCents(),
        inkHex: function (ink) { return resolveColor(ink || zs0.inkColor); },
        uppercase: hangerFieldUppercase,
        reviewed: reviewedVersion,
        letterHeight: fixedLetterHeightMarker()
      });
      pairs.forEach(function (pair) { addCartProperty(form, pair[0], pair[1]); });
      return;
    }

    for (const zs of zoneStates) {
      if (!zs.enabled || !zoneHasEnteredValues(zs)) continue;
      if (!firstEnabled) firstEnabled = zs;
      const id = zs.zoneId;
      addCartProperty(form, '_pers_zone_' + id + '_template', zs.zone.templateId);
      addCartProperty(form, '_pers_zone_' + id + '_location', id);
      for (const [k, v] of Object.entries(zs.values)) {
        if (!v) continue;
        const fieldDef = zs.zone.template.fields.find(f => f.id === k);
        addCartProperty(form, '_pers_zone_' + id + '_field_' + k, fieldDef && fieldDef.uppercase ? v.toUpperCase() : v);
      }
      addCartProperty(form, '_pers_zone_' + id + '_font', zs.font);
      addCartProperty(form, '_pers_zone_' + id + '_ink', resolveColor(zs.inkColor));
      const addon = zoneAddonCents(zs);
      addCartProperty(form, '_pers_zone_' + id + '_addon', (addon / 100).toFixed(2));
      totalAddonCents += addon;
    }
    const enabledCount = zoneStates.filter(zs => zs.enabled && zoneHasEnteredValues(zs)).length;
    if (enabledCount) addCartProperty(form, '_personalization_locations', String(enabledCount));
    if (totalAddonCents > 0) addCartProperty(form, '_personalization_total_addon', (totalAddonCents / 100).toFixed(2));

    if (firstEnabled) {
      addCartProperty(form, '_personalization_template', firstEnabled.zone.templateId);
      if (window.GHOSTFIT_PRODUCT_CONFIG_ID) addCartProperty(form, '_personalization_config_id', window.GHOSTFIT_PRODUCT_CONFIG_ID);
      for (const [k, v] of Object.entries(firstEnabled.values)) {
        if (!v) continue;
        const fieldDef = firstEnabled.zone.template.fields.find(f => f.id === k);
        addCartProperty(form, '_personalization_field_' + k, fieldDef && fieldDef.uppercase ? v.toUpperCase() : v);
      }
      addCartProperty(form, '_personalization_font', firstEnabled.font);
      addCartProperty(form, '_personalization_ink_color', resolveColor(firstEnabled.inkColor));
      addCartProperty(form, '_personalization_addon', (zoneAddonCents(firstEnabled) / 100).toFixed(2));
    }
  }

  // '_personalization_letter_height' value: 'fixed' when the planner loaded
  // (every hanger name and number was drawn with it), else none.
  function fixedLetterHeightMarker() {
    const F = window.GfFixedLetterHeight;
    return F && typeof F.placeHalf === 'function' ? F.LETTER_HEIGHT_MARKER : '';
  }

  function clearCartProperties(form) {
    form.querySelectorAll('input[name^="properties[_pers"], input[name^="properties[_personalization"]').forEach(function (el) {
      el.parentNode.removeChild(el);
    });
  }
  function addCartProperty(form, name, value) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[' + name + ']';
    input.value = value;
    form.appendChild(input);
  }

  function bindExactPreview() {
    if (!exactPreviewBtn) return;
    // Exact preview only supports single-zone products today. For multi-zone,
    // hide the button — it'd be ambiguous which zone to preview.
    if (isMultiZone) {
      exactPreviewBtn.style.display = 'none';
      return;
    }
    exactPreviewBtn.addEventListener('click', async () => {
      const productConfigId = window.GHOSTFIT_PRODUCT_CONFIG_ID;
      if (!productConfigId) { alert('Preview unavailable — missing product config id'); return; }
      const zs = zoneStates[0];
      const body = {
        productConfigId,
        ...zs.values,
        font: zs.font,
        nameColor: resolveColor(zs.inkColor),
        numberColor: resolveColor(zs.inkColor)
      };
      exactPreviewBtn.disabled = true;
      try {
        const res = await fetch('/apps/gf/api/generate-back-mockup', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        });
        if (res.ok) {
          const blob = await res.blob();
          const url = URL.createObjectURL(blob);
          const original = mainImg.src;
          mainImg.src = url;
          setTimeout(() => { mainImg.src = original; URL.revokeObjectURL(url); }, 3000);
        }
      } finally {
        exactPreviewBtn.disabled = false;
      }
    });
  }

  // -------------------------------------------------------------------
  // Boot
  // -------------------------------------------------------------------
  buildAllCards();
  if (wisconsinActive()) {
    applyWisconsinLocationState();
  }
  bindHandlers();
  bindExactPreview();
  bindRegularFrameRerender();
  renderAllZonesSVG();
  updatePricing();
  applyAllZoneVisibility();
  startHangerView();
  initialSnapshot = snapshotPersonalization();
  window.GhostFitPersonalization = Object.freeze({
    snapshot: snapshotPersonalization, restore: restorePersonalization,
    reset: resetAllPersonalization, status: personalizationStatus, validate: validatePersonalization,
    previewPlacement: activePreviewPlacement, start: startHangerView,
    review: reviewModel, markReviewed: markReviewed
  });
  zonesContainer.dispatchEvent(new CustomEvent('gf:pers-ready', { bubbles: true }));

  // Auto-fit measures glyph widths, so a render that ran before the webfonts
  // arrived used fallback metrics — re-render once fonts are ready.
  if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
    document.fonts.ready.then(() => renderAllZonesSVG());
  }
  // The store face is only requested once text first draws in it, AFTER
  // fonts.ready has resolved, so that first draw is measured on the fallback
  // face (a back name came out 9% too big until the next keystroke). Redraw
  // when any face finishes loading. One listener per page, always drawing the
  // latest initialize()'s zones (it also runs on shopify:section:load).
  redrawOnFontLoad = renderAllZonesSVG;
  if (document.fonts && typeof document.fonts.addEventListener === 'function' && !fontLoadRedrawBound) {
    fontLoadRedrawBound = true;
    document.fonts.addEventListener('loadingdone', () => { if (redrawOnFontLoad) redrawOnFontLoad(); });
  }
  }
  let fontLoadRedrawBound = false;
  let redrawOnFontLoad = null;
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
